import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddPaymentCardInput = {
  isPrimary?: Maybe<Scalars['Boolean']>;
  last4Digits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProviderToken?: Maybe<Scalars['String']>;
};

export type AddToMailingListInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type AuthInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthenticateUserOutput = {
  __typename?: 'AuthenticateUserOutput';
  /**
   *
   *
   */
  token: Scalars['String'];
  /**
   *
   *
   */
  user: CommonUserOutput;
};

export type AuthorisedPersonOutput = {
  __typename?: 'AuthorisedPersonOutput';
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  name: Scalars['String'];
  /**
   *
   *
   */
  phoneNumber: Scalars['String'];
  /**
   *
   *
   */
  relationship: Scalars['String'];
};

export type AutocompleteListOutput = {
  __typename?: 'AutocompleteListOutput';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  key?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  values: Array<StringValueOutput>;
};

export type BasketItemOutput = {
  __typename?: 'BasketItemOutput';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  patientMedication?: Maybe<PatientMedicationOutput>;
  /**
   *
   *
   */
  price: Scalars['Int'];
  /**
   *
   *
   */
  quantity: Scalars['Int'];
  /**
   *
   *
   */
  saleTax: Scalars['Int'];
};

export type BasketOutput = {
  __typename?: 'BasketOutput';
  /**
   *
   *
   */
  deliveryAddress?: Maybe<CustomerAddressOutput>;
  /**
   *
   *
   */
  discount?: Maybe<DiscountOutput>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  itemCount: Scalars['Int'];
  /**
   *
   *
   */
  itemPriceTotal: Scalars['Int'];
  /**
   *
   *
   */
  itemSaleTaxTotal: Scalars['Int'];
  /**
   *
   *
   */
  items: Array<BasketItemOutput>;
  /**
   *
   *
   */
  orderId?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  saleTaxTotal: Scalars['Int'];
  /**
   *
   *
   */
  shippingPrice: Scalars['Int'];
  /**
   *
   *
   */
  shippingSaleTax: Scalars['Int'];
  /**
   *
   *
   */
  shippingTotalPrice: Scalars['Int'];
  /**
   *
   *
   */
  totalAuthorised: Scalars['Int'];
  /**
   *
   *
   */
  totalBeforeSaleTax: Scalars['Int'];
  /**
   *
   *
   */
  totalRemaining: Scalars['Int'];
  /**
   *
   *
   */
  totalWithSaleTax: Scalars['Int'];
};

export type BeginHealthServiceSignupInput = {
  email: Scalars['String'];
};

export type CardPaymentOutput = {
  __typename?: 'CardPaymentOutput';
  /**
   *
   *
   */
  amount: Scalars['Int'];
  /**
   *
   *
   */
  authorisationCode?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  authorisedAmount: Scalars['Int'];
  /**
   *
   *
   */
  cardToken?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  did3dsAuthenticationPass: Scalars['Boolean'];
  /**
   *
   *
   */
  error?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  isAuthorised: Scalars['Boolean'];
  /**
   *
   *
   */
  merchantSessionKey?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  paymentCard?: Maybe<PaymentCardOutput>;
  /**
   *
   *
   */
  providerError?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  scaUrl?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  urlFor3ds?: Maybe<Scalars['String']>;
};

export type ChangeCustomerEmailInput = {
  email: Scalars['String'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type CheckStatusResponseOutput = {
  __typename?: 'CheckStatusResponseOutput';
  /**
   *
   *
   */
  actions: Array<Scalars['String']>;
  /**
   *
   *
   */
  missingProperties: Array<Scalars['String']>;
};

export type CommonUserOutput = CommonUserOutputInterface & {
  __typename?: 'CommonUserOutput';
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  unverifiedEmail?: Maybe<Scalars['String']>;
};

export type CommonUserOutputInterface = {
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  unverifiedEmail?: Maybe<Scalars['String']>;
};

export type ContactGpPrescriptionChaseTaskOutput = TaskOutputInterface & {
  __typename?: 'ContactGPPrescriptionChaseTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  nhsSurgery?: Maybe<NhsSurgeryOutput>;
  /**
   *
   *
   */
  orders?: Maybe<Array<RepeatPrescriptionOrderOutput>>;
  /**
   *
   *
   */
  parentTask?: Maybe<TaskOutputInterface>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type ContactGpPrescriptionRequestTaskOutput = TaskOutputInterface & {
  __typename?: 'ContactGPPrescriptionRequestTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  nhsSurgery?: Maybe<NhsSurgeryOutput>;
  /**
   *
   *
   */
  orders?: Maybe<Array<RepeatPrescriptionOrderOutput>>;
  /**
   *
   *
   */
  parentTask?: Maybe<TaskOutputInterface>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type ContactPatientOutput = {
  __typename?: 'ContactPatientOutput';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  message?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  reasonForContact: ReasonForContactOutput;
};

export type ContactPharmacyTaskOutput = TaskOutputInterface & {
  __typename?: 'ContactPharmacyTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  nhsSurgery?: Maybe<NhsSurgeryOutput>;
  /**
   *
   *
   */
  orders?: Maybe<Array<RepeatPrescriptionOrderOutput>>;
  /**
   *
   *
   */
  parentTask?: Maybe<TaskOutputInterface>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type CreateCardPaymentInput = {
  basketId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
};

export type CreateCustomerNoteInput = {
  message?: Maybe<Scalars['String']>;
};

export type CreateOrderNoteInput = {
  message?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
};

export type CustomerAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  addressLine4?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  postcode: Scalars['String'];
};

export type CustomerAddressOutput = {
  __typename?: 'CustomerAddressOutput';
  /**
   *
   *
   */
  addressLine1: Scalars['String'];
  /**
   *
   *
   */
  addressLine2?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine3?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine4?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  city: Scalars['String'];
  /**
   *
   *
   */
  country: Scalars['String'];
  /**
   *
   *
   */
  county?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  friendlyName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  postcode: Scalars['String'];
};

export type CustomerDeactivationOutput = {
  __typename?: 'CustomerDeactivationOutput';
  /**
   *
   *
   */
  customerDeactivationReason: CustomerDeactivationReasonOutput;
  /**
   *
   *
   */
  id: Scalars['ID'];
};

export type CustomerDeactivationReasonOutput = {
  __typename?: 'CustomerDeactivationReasonOutput';
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  isDefault: Scalars['Boolean'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type CustomerForOrderOutput = {
  __typename?: 'CustomerForOrderOutput';
  /**
   *
   *
   */
  firstName: Scalars['String'];
  /**
   *
   *
   */
  fullName: Scalars['String'];
  /**
   *
   *
   */
  lastName: Scalars['String'];
};

export type CustomerInfoOutput = {
  __typename?: 'CustomerInfoOutput';
  /**
   *
   *
   */
  allowSmsUpdates: Scalars['Boolean'];
  /**
   *
   *
   */
  dateOfBirth?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  defaultAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  email: Scalars['String'];
  /**
   *
   *
   */
  firstName: Scalars['String'];
  /**
   *
   *
   */
  fullName: Scalars['String'];
  /**
   *
   *
   */
  gender: Scalars['String'];
  /**
   *
   *
   */
  hasHealthServiceAccount: Scalars['Boolean'];
  /**
   *
   *
   */
  healthServicePatientAccount?: Maybe<HealthServicePatientAccountOutput>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  lastName: Scalars['String'];
  /**
   *
   *
   */
  phoneNumber: Scalars['String'];
  /**
   *
   *
   */
  preferredContactMethod: Scalars['String'];
  /**
   *
   *
   */
  primaryDeliveryAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  primaryPaymentMethod?: Maybe<PaymentCardOutput>;
  /**
   *
   *
   */
  requiresExemptionStatusCheck: Scalars['Boolean'];
  /**
   *
   *
   */
  smsPhoneNumber?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  unverifiedEmail?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  unverifiedSmsPhoneNumber?: Maybe<Scalars['String']>;
};

export type CustomerOutput = CommonUserOutputInterface & {
  __typename?: 'CustomerOutput';
  /**
   *
   *
   */
  age: Scalars['Int'];
  /**
   *
   *
   */
  allowSmsUpdates: Scalars['Boolean'];
  /**
   *
   *
   */
  authorisedPersons: Array<AuthorisedPersonOutput>;
  /**
   *
   *
   */
  complianceAid: Scalars['String'];
  /**
   *
   *
   */
  customerDeactivation?: Maybe<CustomerDeactivationOutput>;
  /**
   *
   *
   */
  dateOfBirth: Scalars['String'];
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  defaultAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  deliveryAddresses: Array<CustomerAddressOutput>;
  /**
   *
   *
   */
  email: Scalars['String'];
  /**
   *
   *
   */
  exemption?: Maybe<ExemptionOutput>;
  /**
   *
   *
   */
  firstName: Scalars['String'];
  /**
   *
   *
   */
  gender: Scalars['String'];
  /**
   *
   *
   */
  healthServicePatientAccount?: Maybe<HealthServicePatientAccountOutput>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  isDeactivated: Scalars['Boolean'];
  /**
   *
   *
   */
  lastName: Scalars['String'];
  /**
   *
   *
   */
  notes: Array<NoteOutput>;
  /**
   *
   *
   */
  orders: PaginatorResult_RepeatPrescriptionOrderOutput;
  /**
   *
   *
   */
  phoneNumber: Scalars['String'];
  /**
   *
   *
   */
  preferredContactMethod: Scalars['String'];
  /**
   *
   *
   */
  primaryDeliveryAddress?: Maybe<CustomerAddressOutput>;
  /**
   *
   *
   */
  smsPhoneNumber?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  tasks: PaginatorResult_TaskOutputInterface;
  /**
   *
   *
   */
  unverifiedEmail?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  unverifiedSmsPhoneNumber?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  urgentContactMethod: Scalars['String'];
};


export type CustomerOutputOrdersArgs = {
  paginationInput?: Maybe<PaginationInput>;
};


export type CustomerOutputTasksArgs = {
  filter?: Maybe<TaskFilterInput>;
  paginationInput?: Maybe<PaginationInput>;
};

export type DeleteCustomerInput = {
  reason?: Maybe<Scalars['String']>;
};

export type DeleteOrderNoteInput = {
  noteId?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
};

export type DeliveryServiceOutput = {
  __typename?: 'DeliveryServiceOutput';
  /**
   *
   *
   */
  description: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  name: Scalars['String'];
  /**
   *
   *
   */
  providerCode: Scalars['String'];
};

export type DiscountOutput = {
  __typename?: 'DiscountOutput';
  /**
   *
   *
   */
  code: Scalars['String'];
  /**
   *
   *
   */
  description: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['String'];
};

export type ExemptionOutput = {
  __typename?: 'ExemptionOutput';
  /**
   *
   *
   */
  exemptionReason: ExemptionReasonOutput;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
};

export type ExemptionReasonOutput = {
  __typename?: 'ExemptionReasonOutput';
  /**
   *
   *
   */
  code: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type ExportToRobotTaskOutput = TaskOutputInterface & {
  __typename?: 'ExportToRobotTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type FtcGeneralTaskOutput = TaskOutputInterface & {
  __typename?: 'FTCGeneralTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  parentTask?: Maybe<TaskOutputInterface>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type FtcNominationTaskOutput = TaskOutputInterface & {
  __typename?: 'FTCNominationTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type GeolocationAddressOutput = {
  __typename?: 'GeolocationAddressOutput';
  /**
   *
   *
   */
  addressLine1: Scalars['String'];
  /**
   *
   *
   */
  addressLine2?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine3?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine4?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  county?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  latitude: Scalars['Float'];
  /**
   *
   *
   */
  longitude: Scalars['Float'];
  /**
   *
   *
   */
  postcode: Scalars['String'];
  /**
   *
   *
   */
  summaryLine: Scalars['String'];
};

export type GetStaticContentInput = {
  key: Scalars['String'];
};

export type HealthServicePatientAccountOutput = {
  __typename?: 'HealthServicePatientAccountOutput';
  /**
   *
   *
   */
  canHealthServiceVerify: Scalars['Boolean'];
  /**
   *
   *
   */
  complianceAid: Scalars['String'];
  /**
   *
   *
   */
  exemption?: Maybe<ExemptionOutput>;
  /**
   *
   *
   */
  hasExemption: Scalars['Boolean'];
  /**
   *
   *
   */
  healthServiceIdentifier?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  healthServiceIdentifierLabel: Scalars['String'];
  /**
   *
   *
   */
  healthServiceProvider: Scalars['String'];
  /**
   *
   *
   */
  healthServiceVerificationStatus: Scalars['String'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  patientMedications: Array<PatientMedicationOutput>;
  /**
   *
   *
   */
  preferredPharmacy?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  requiresExemptionConfirmation: Scalars['Boolean'];
  /**
   *
   *
   */
  selfManagesPrescriptions: Scalars['Boolean'];
  /**
   *
   *
   */
  surgery?: Maybe<NhsSurgeryOutput>;
};

export type HealthServicePatientAccountUpdateInput = {
  exemptionReasonId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type HealthServiceSignupInput = {
  dateOfBirth: Scalars['String'];
  defaultAddress: CustomerAddressInput;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  hasMarketingOptIn: Scalars['Boolean'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  surgeryId: Scalars['String'];
  termsAgreed: Scalars['Boolean'];
};

export type HealthServiceSignupOutput = {
  __typename?: 'HealthServiceSignupOutput';
  /**
   *
   *
   */
  token: Scalars['String'];
  /**
   *
   *
   */
  user: CustomerInfoOutput;
};

export type HealthServiceVerifyPatientInput = {
  dateOfBirth: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  postcode: Scalars['String'];
};

export type IdInput = {
  id?: Scalars['String'];
};

export type MailingListOutput = {
  __typename?: 'MailingListOutput';
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  name: Scalars['String'];
};

export type MailingListSubscriberOutput = {
  __typename?: 'MailingListSubscriberOutput';
  /**
   *
   *
   */
  email: Scalars['String'];
  /**
   *
   *
   */
  firstName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  lastName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  surgeryId?: Maybe<Scalars['String']>;
};

export type MedicationCheckTaskOutput = TaskOutputInterface & {
  __typename?: 'MedicationCheckTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type MedicationForRepeatPrescriptionOrderItemOutput = {
  __typename?: 'MedicationForRepeatPrescriptionOrderItemOutput';
  /**
   *
   *
   */
  formName: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  isControlled: Scalars['Boolean'];
  /**
   *
   *
   */
  isFridgeLine: Scalars['Boolean'];
  /**
   *
   *
   */
  name: Scalars['String'];
  /**
   *
   *
   */
  prescriptionCharges: Scalars['Int'];
};

export type MedicationOutput = {
  __typename?: 'MedicationOutput';
  /**
   *
   *
   */
  familyName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  formCategory?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  formName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  isControlled: Scalars['Boolean'];
  /**
   *
   *
   */
  isFemaleContraceptive: Scalars['Boolean'];
  /**
   *
   *
   */
  isFridgeLine: Scalars['Boolean'];
  /**
   *
   *
   */
  longDisplayName: Scalars['String'];
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  optionName?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  prescriptionCharges: Scalars['Int'];
  /**
   *
   *
   */
  shortDisplayName: Scalars['String'];
  /**
   *
   *
   */
  shortFormName?: Maybe<Scalars['String']>;
};

export type MedicationSearchHit = {
  __typename?: 'MedicationSearchHit';
  /**
   *
   *
   */
  familyFormName: Scalars['String'];
  /**
   *
   *
   */
  familyName: Scalars['String'];
  /**
   *
   *
   */
  formCategory: Scalars['String'];
  /**
   *
   *
   */
  formName: Scalars['String'];
  /**
   *
   *
   */
  longDisplayName: Scalars['String'];
  /**
   *
   *
   */
  medicationId: Scalars['String'];
  /**
   *
   *
   */
  name: Scalars['String'];
  /**
   *
   *
   */
  optionName: Scalars['String'];
  /**
   *
   *
   */
  shortDisplayName: Scalars['String'];
  /**
   *
   *
   */
  shortFormName: Scalars['String'];
};

export type MessageOutput = {
  __typename?: 'MessageOutput';
  /**
   *
   *
   */
  direction: Scalars['Boolean'];
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  message: Scalars['String'];
  /**
   *
   *
   */
  type: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   *
   */
  addDeliveryAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  addPatientMedication?: Maybe<PatientMedicationOutput>;
  /**
   *
   *
   */
  addPaymentCard: PaymentCardOutput;
  /**
   *
   *
   */
  addToMailingList: MailingListSubscriberOutput;
  /**
   *
   *
   */
  authenticate: AuthenticateUserOutput;
  /**
   *
   *
   */
  beginHealthServiceSignup: Scalars['Boolean'];
  /**
   *
   *
   */
  changeCustomerEmail: Scalars['Boolean'];
  /**
   *
   *
   */
  changePassword: Scalars['Boolean'];
  /**
   *
   *
   */
  createCardPayment: CardPaymentOutput;
  /**
   *
   *
   */
  createCustomerNote: NoteOutput;
  /**
   *
   *
   */
  createOrderNote: NoteOutput;
  /**
   *
   *
   */
  createRepeatPrescriptionBasket: BasketOutput;
  /**
   *
   *
   */
  deleteCustomer: Scalars['Boolean'];
  /**
   *
   *
   */
  deleteCustomerNote: Scalars['Boolean'];
  /**
   *
   *
   */
  deleteDeliveryAddress: Scalars['Boolean'];
  /**
   *
   *
   */
  deleteOrderNote: Scalars['Boolean'];
  /**
   *
   *
   */
  deletePatientMedication: Scalars['Boolean'];
  /**
   *
   *
   */
  deletePaymentCard: Scalars['Boolean'];
  /**
   *
   *
   */
  deregisterNHSIM1: Scalars['Boolean'];
  /**
   *
   *
   */
  emptyBasket: BasketOutput;
  /**
   *
   *
   */
  healthServicePatientAccountUpdate: Scalars['Boolean'];
  /**
   *
   *
   */
  healthServiceSignup: HealthServiceSignupOutput;
  /**
   *
   *
   */
  healthServiceVerifyPatient: HealthServicePatientAccountOutput;
  /**
   *
   *
   */
  logout: Scalars['Boolean'];
  /**
   *
   *
   */
  refreshToken: Scalars['String'];
  /**
   *
   *
   */
  resendVerificationEmail: Scalars['Boolean'];
  /**
   *
   *
   */
  resendVerificationSms: Scalars['Boolean'];
  /**
   *
   *
   */
  resetPassword: Scalars['Boolean'];
  /**
   *
   *
   */
  saveSurgeryInterest: Scalars['Boolean'];
  /**
   *
   *
   */
  sendResetPasswordEmail?: Maybe<Scalars['Boolean']>;
  /**
   *
   *
   */
  setPrimaryDeliveryAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  setPrimaryPaymentMethod: PaymentCardOutput;
  /**
   *
   *
   */
  submitCardPayment: CardPaymentOutput;
  /**
   *
   *
   */
  submitRepeatPrescriptionBasket: BasketOutput;
  /**
   *
   *
   */
  updateCardPayment: CardPaymentOutput;
  /**
   *
   *
   */
  updateCustomerContactPreferences: Scalars['Boolean'];
  /**
   *
   *
   */
  updateCustomerDetails: Scalars['Boolean'];
  /**
   *
   *
   */
  updateCustomerNote: NoteOutput;
  /**
   *
   *
   */
  updateDeliveryAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  updateNHSIM1?: Maybe<NhsIm1AuthConnectionOutput>;
  /**
   *
   *
   */
  updateOrderNote: NoteOutput;
  /**
   *
   *
   */
  updatePaymentCard?: Maybe<PaymentCardOutput>;
  /**
   *
   *
   */
  updateRepeatPrescriptionBasket: BasketOutput;
  /**
   *
   *
   */
  verifyEmail: Scalars['Boolean'];
  /**
   *
   *
   */
  verifySmsPhoneNumber: Scalars['Boolean'];
};


export type MutationAddDeliveryAddressArgs = {
  input?: Maybe<CustomerAddressInput>;
};


export type MutationAddPatientMedicationArgs = {
  medicationId: Scalars['String'];
  requiredAt: Scalars['String'];
};


export type MutationAddPaymentCardArgs = {
  input?: Maybe<AddPaymentCardInput>;
};


export type MutationAddToMailingListArgs = {
  input?: Maybe<AddToMailingListInput>;
};


export type MutationAuthenticateArgs = {
  input: AuthInput;
};


export type MutationBeginHealthServiceSignupArgs = {
  input: BeginHealthServiceSignupInput;
};


export type MutationChangeCustomerEmailArgs = {
  input: ChangeCustomerEmailInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateCardPaymentArgs = {
  input?: Maybe<CreateCardPaymentInput>;
};


export type MutationCreateCustomerNoteArgs = {
  input?: Maybe<CreateCustomerNoteInput>;
};


export type MutationCreateOrderNoteArgs = {
  input?: Maybe<CreateOrderNoteInput>;
};


export type MutationCreateRepeatPrescriptionBasketArgs = {
  input: RepeatPrescriptionBasketInput;
};


export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


export type MutationDeleteCustomerNoteArgs = {
  input?: Maybe<IdInput>;
};


export type MutationDeleteDeliveryAddressArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrderNoteArgs = {
  input?: Maybe<DeleteOrderNoteInput>;
};


export type MutationDeletePatientMedicationArgs = {
  id: Scalars['String'];
};


export type MutationDeletePaymentCardArgs = {
  id: Scalars['String'];
};


export type MutationEmptyBasketArgs = {
  id: Scalars['String'];
};


export type MutationHealthServicePatientAccountUpdateArgs = {
  input?: Maybe<HealthServicePatientAccountUpdateInput>;
};


export type MutationHealthServiceSignupArgs = {
  input: HealthServiceSignupInput;
};


export type MutationHealthServiceVerifyPatientArgs = {
  input: HealthServiceVerifyPatientInput;
};


export type MutationResendVerificationSmsArgs = {
  input: ResendVerificationSmsInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveSurgeryInterestArgs = {
  input?: Maybe<SaveSurgeryInterestInput>;
};


export type MutationSendResetPasswordEmailArgs = {
  input: SendResetPasswordEmailInput;
};


export type MutationSetPrimaryDeliveryAddressArgs = {
  id: Scalars['String'];
};


export type MutationSetPrimaryPaymentMethodArgs = {
  id: Scalars['String'];
};


export type MutationSubmitCardPaymentArgs = {
  id: Scalars['String'];
};


export type MutationSubmitRepeatPrescriptionBasketArgs = {
  input: IdInput;
};


export type MutationUpdateCardPaymentArgs = {
  id: Scalars['String'];
  input?: Maybe<UpdateCardPaymentInput>;
};


export type MutationUpdateCustomerContactPreferencesArgs = {
  input: UpdateCustomerContactPreferencesInput;
};


export type MutationUpdateCustomerDetailsArgs = {
  input: UpdateCustomerDetailsInput;
};


export type MutationUpdateCustomerNoteArgs = {
  input?: Maybe<UpdateCustomerNoteInput>;
};


export type MutationUpdateDeliveryAddressArgs = {
  id: Scalars['String'];
  input?: Maybe<CustomerAddressInput>;
};


export type MutationUpdateNhsim1Args = {
  input?: Maybe<UpdateNhsIm1Input>;
};


export type MutationUpdateOrderNoteArgs = {
  input?: Maybe<UpdateOrderNoteInput>;
};


export type MutationUpdatePaymentCardArgs = {
  input?: Maybe<UpdatePaymentCardInput>;
};


export type MutationUpdateRepeatPrescriptionBasketArgs = {
  id: Scalars['String'];
  input?: Maybe<RepeatPrescriptionBasketInput>;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifySmsPhoneNumberArgs = {
  input: VerifySmsPhoneNumberInput;
};

export type NhsIm1AuthConnectionOutput = {
  __typename?: 'NhsIm1AuthConnectionOutput';
  /**
   *
   *
   */
  gpLinkageKey?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  gpOdsCode?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  gpUserId?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
};

export type NhsSurgeryAddressOutput = {
  __typename?: 'NhsSurgeryAddressOutput';
  /**
   *
   *
   */
  addressLine1: Scalars['String'];
  /**
   *
   *
   */
  addressLine2?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine3?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  addressLine4?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  county?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  postcode: Scalars['String'];
};

export type NhsSurgeryOutput = {
  __typename?: 'NhsSurgeryOutput';
  /**
   *
   *
   */
  address: NhsSurgeryAddressOutput;
  /**
   *
   *
   */
  contactMethod: Scalars['String'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  isEpsEnabled: Scalars['Boolean'];
  /**
   *
   *
   */
  name: Scalars['String'];
  /**
   *
   *
   */
  phoneNumber?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  providesPatients: Scalars['Boolean'];
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']>;
};

export type NominationTaskOutput = TaskOutputInterface & {
  __typename?: 'NominationTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type NoteOutput = {
  __typename?: 'NoteOutput';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  message: Scalars['String'];
};

export type NoteTemplateOutput = {
  __typename?: 'NoteTemplateOutput';
  /**
   *
   *
   */
  content: Scalars['String'];
  /**
   *
   *
   */
  description: Scalars['String'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  name: Scalars['String'];
};

export type OrderCancelReasonOutput = {
  __typename?: 'OrderCancelReasonOutput';
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type OrderCancellationOutput = {
  __typename?: 'OrderCancellationOutput';
  /**
   *
   *
   */
  cancelledAt: Scalars['String'];
  /**
   *
   *
   */
  cancelledBy: CommonUserOutputInterface;
  /**
   *
   *
   */
  customCancelReason: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  orderCancelReason: OrderCancelReasonOutput;
};

export type OrderNoteOutput = {
  __typename?: 'OrderNoteOutput';
  /**
   *
   *
   */
  createdAt: Scalars['String'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  message: Scalars['String'];
  /**
   *
   *
   */
  statusFrom: StatusOutput;
  /**
   *
   *
   */
  statusTo: StatusOutput;
  /**
   *
   *
   */
  updatedAt: Scalars['String'];
};

export type OrderPauseOutput = {
  __typename?: 'OrderPauseOutput';
  /**
   *
   *
   */
  customPauseReason: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  orderPauseReason: OrderPauseReasonOutput;
  /**
   *
   *
   */
  pauseUntil: Scalars['String'];
  /**
   *
   *
   */
  pausedAt: Scalars['String'];
  /**
   *
   *
   */
  pausedBy: CommonUserOutputInterface;
  /**
   *
   *
   */
  unpausedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  unpausedBy?: Maybe<CommonUserOutputInterface>;
};

export type OrderPauseReasonOutput = {
  __typename?: 'OrderPauseReasonOutput';
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type OrderSplitOutput = {
  __typename?: 'OrderSplitOutput';
  /**
   *
   *
   */
  customSplitReason: Scalars['String'];
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  orderSplitReason: OrderSplitReasonOutput;
  /**
   *
   *
   */
  splitAt: Scalars['String'];
  /**
   *
   *
   */
  splitBy: CommonUserOutputInterface;
};

export type OrderSplitReasonOutput = {
  __typename?: 'OrderSplitReasonOutput';
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type PaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatorResult_MailingListOutput = {
  __typename?: 'PaginatorResult_MailingListOutput';
  /** Determine the current page being paginated. */
  currentPage?: Maybe<Scalars['Int']>;
  /** Get the "index" of the first item being paginated. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Determine if there are more items in the data source. */
  hasMorePages?: Maybe<Scalars['Boolean']>;
  /** Determine if there are enough items to split into multiple pages. */
  hasPages?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is empty or not. */
  isEmpty?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is not empty. */
  isNotEmpty?: Maybe<Scalars['Boolean']>;
  items: Array<MailingListOutput>;
  /** Get the "index" of the last item being paginated. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Get the page number of the last available page. */
  lastPage?: Maybe<Scalars['Int']>;
  /** Get the number of items shown per page. */
  perPage?: Maybe<Scalars['Int']>;
  /** The total count of items. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatorResult_RepeatPrescriptionOrderOutput = {
  __typename?: 'PaginatorResult_RepeatPrescriptionOrderOutput';
  /** Determine the current page being paginated. */
  currentPage?: Maybe<Scalars['Int']>;
  /** Get the "index" of the first item being paginated. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Determine if there are more items in the data source. */
  hasMorePages?: Maybe<Scalars['Boolean']>;
  /** Determine if there are enough items to split into multiple pages. */
  hasPages?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is empty or not. */
  isEmpty?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is not empty. */
  isNotEmpty?: Maybe<Scalars['Boolean']>;
  items: Array<RepeatPrescriptionOrderOutput>;
  /** Get the "index" of the last item being paginated. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Get the page number of the last available page. */
  lastPage?: Maybe<Scalars['Int']>;
  /** Get the number of items shown per page. */
  perPage?: Maybe<Scalars['Int']>;
  /** The total count of items. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatorResult_TaskOutputInterface = {
  __typename?: 'PaginatorResult_TaskOutputInterface';
  /** Determine the current page being paginated. */
  currentPage?: Maybe<Scalars['Int']>;
  /** Get the "index" of the first item being paginated. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Determine if there are more items in the data source. */
  hasMorePages?: Maybe<Scalars['Boolean']>;
  /** Determine if there are enough items to split into multiple pages. */
  hasPages?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is empty or not. */
  isEmpty?: Maybe<Scalars['Boolean']>;
  /** Determine if the list of items is not empty. */
  isNotEmpty?: Maybe<Scalars['Boolean']>;
  items: Array<TaskOutputInterface>;
  /** Get the "index" of the last item being paginated. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Get the page number of the last available page. */
  lastPage?: Maybe<Scalars['Int']>;
  /** Get the number of items shown per page. */
  perPage?: Maybe<Scalars['Int']>;
  /** The total count of items. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type PatientMedicationOutput = {
  __typename?: 'PatientMedicationOutput';
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  medication: MedicationOutput;
  /**
   *
   *
   */
  requiredAt?: Maybe<Scalars['String']>;
};

export type PaymentCardOutput = {
  __typename?: 'PaymentCardOutput';
  /**
   *
   *
   */
  brand?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  last4Digits?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  paymentProviderToken?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  type: Scalars['String'];
};

export type PaymentProviderOutput = {
  __typename?: 'PaymentProviderOutput';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  name: Scalars['String'];
};

export type PermissionOutput = {
  __typename?: 'PermissionOutput';
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  friendlyName: Scalars['String'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
};

export type PhoneNumberOutput = {
  __typename?: 'PhoneNumberOutput';
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  number: Scalars['String'];
};

export type PrescriptionStatusTaskOutput = TaskOutputInterface & {
  __typename?: 'PrescriptionStatusTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  order?: Maybe<RepeatPrescriptionOrderOutput>;
  /**
   *
   *
   */
  response?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /**
   *
   *
   */
  basket: BasketOutput;
  /**
   *
   *
   */
  cardPayment: CardPaymentOutput;
  /**
   *
   *
   */
  checkStatus?: Maybe<CheckStatusResponseOutput>;
  /**
   *
   *
   */
  deliveryAddress: CustomerAddressOutput;
  /**
   *
   *
   */
  deliveryAddresses: Array<CustomerAddressOutput>;
  /**
   *
   *
   */
  exemptionReasons: Array<ExemptionReasonOutput>;
  /**
   *
   *
   */
  fetchMailingLists: PaginatorResult_MailingListOutput;
  /**
   *
   *
   */
  medicationSearch: Array<MedicationSearchHit>;
  /**
   *
   *
   */
  noteTemplates: Array<NoteTemplateOutput>;
  /**
   *
   *
   */
  order: RepeatPrescriptionOrderOutput;
  /**
   *
   *
   */
  orders: PaginatorResult_RepeatPrescriptionOrderOutput;
  /**
   *
   *
   */
  patientMedication?: Maybe<PatientMedicationOutput>;
  /**
   *
   *
   */
  patientMedications: Array<PatientMedicationOutput>;
  /**
   *
   *
   */
  paymentCard?: Maybe<PaymentCardOutput>;
  /**
   *
   *
   */
  paymentMethods: Array<PaymentCardOutput>;
  /**
   *
   *
   */
  preferredPharmacy?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  searchForPostcode: Array<GeolocationAddressOutput>;
  /**
   *
   *
   */
  staticContent?: Maybe<StaticContentOutput>;
  /**
   *
   *
   */
  surgerySearch: Array<NhsSurgeryOutput>;
  /**
   *
   *
   */
  userInfo: CustomerInfoOutput;
};


export type QueryBasketArgs = {
  id: Scalars['String'];
};


export type QueryCardPaymentArgs = {
  id: Scalars['String'];
};


export type QueryCheckStatusArgs = {
  status: Scalars['String'];
};


export type QueryDeliveryAddressArgs = {
  id: Scalars['String'];
};


export type QueryFetchMailingListsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMedicationSearchArgs = {
  family?: Maybe<Scalars['String']>;
  query: Scalars['String'];
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryOrdersArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryPatientMedicationArgs = {
  id: Scalars['String'];
};


export type QueryPaymentCardArgs = {
  id: Scalars['String'];
};


export type QuerySearchForPostcodeArgs = {
  page?: Maybe<Scalars['Int']>;
  postcode: Scalars['String'];
};


export type QueryStaticContentArgs = {
  input?: Maybe<GetStaticContentInput>;
};


export type QuerySurgerySearchArgs = {
  postcode?: Maybe<Scalars['String']>;
};

export type ReasonForContactOutput = {
  __typename?: 'ReasonForContactOutput';
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  reason: Scalars['String'];
};

export type RepeatPrescriptionBasketInput = {
  deliveryAddressId?: Maybe<Scalars['String']>;
  patientMedicationIds?: Maybe<Array<Scalars['String']>>;
};

export type RepeatPrescriptionOrderItemOutput = {
  __typename?: 'RepeatPrescriptionOrderItemOutput';
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  medication: MedicationForRepeatPrescriptionOrderItemOutput;
  /**
   *
   *
   */
  price: Scalars['Int'];
  /**
   *
   *
   */
  status: StatusOutput;
};

export type RepeatPrescriptionOrderOutput = {
  __typename?: 'RepeatPrescriptionOrderOutput';
  /**
   *
   *
   */
  childOrders: Array<RepeatPrescriptionOrderOutput>;
  /**
   *
   *
   */
  complianceAid: Scalars['String'];
  /**
   *
   *
   */
  createdAt: Scalars['String'];
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  deliveryAddress?: Maybe<CustomerAddressOutput>;
  /**
   *
   *
   */
  exemption?: Maybe<ExemptionOutput>;
  /**
   *
   *
   */
  id: Scalars['String'];
  /**
   *
   *
   */
  isPaused: Scalars['Boolean'];
  /**
   *
   *
   */
  isSplit: Scalars['Boolean'];
  /**
   *
   *
   */
  itemPriceTotal: Scalars['Int'];
  /**
   *
   *
   */
  itemSaleTaxTotal: Scalars['Int'];
  /**
   *
   *
   */
  items: Array<RepeatPrescriptionOrderItemOutput>;
  /**
   *
   *
   */
  notes: Array<OrderNoteOutput>;
  /**
   *
   *
   */
  orderNotes: Array<OrderNoteOutput>;
  /**
   *
   *
   */
  orderNumber: Scalars['String'];
  /**
   *
   *
   */
  orderType: Scalars['String'];
  /**
   *
   *
   */
  parentOrder?: Maybe<RepeatPrescriptionOrderOutput>;
  /**
   *
   *
   */
  pauseUntil?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  payments: Array<CardPaymentOutput>;
  /**
   *
   *
   */
  saleTaxTotal: Scalars['Int'];
  /**
   *
   *
   */
  shippedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  shippingPrice: Scalars['Int'];
  /**
   *
   *
   */
  shippingSaleTax: Scalars['Int'];
  /**
   *
   *
   */
  status: StatusOutput;
  /**
   *
   *
   */
  totalBeforeSaleTax: Scalars['Int'];
  /**
   *
   *
   */
  totalWithSaleTax: Scalars['Int'];
};

export type RescheduleTaskOutput = TaskOutputInterface & {
  __typename?: 'RescheduleTaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  rescheduleDateTime?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  rescheduledBy: CommonUserOutputInterface;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  task?: Maybe<TaskOutputInterface>;
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type ResendVerificationSmsInput = {
  smsPhoneNumber: Scalars['String'];
};

export type ResetPasswordInput = {
  code: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type RoleOutput = {
  __typename?: 'RoleOutput';
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  friendlyName: Scalars['String'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  name: Scalars['String'];
};

export type SaveSurgeryInterestInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type SendResetPasswordEmailInput = {
  email: Scalars['String'];
};

export type StaticContentOutput = {
  __typename?: 'StaticContentOutput';
  /**
   *
   *
   */
  content?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']>;
  /**
   *
   *
   */
  key: Scalars['String'];
};

export type StatusOutput = {
  __typename?: 'StatusOutput';
  /**
   *
   *
   */
  description: Scalars['String'];
  /**
   *
   *
   */
  key: Scalars['String'];
  /**
   *
   *
   */
  level: Scalars['String'];
  /**
   *
   *
   */
  title: Scalars['String'];
};

export type StringValueOutput = {
  __typename?: 'StringValueOutput';
  /**
   *
   *
   */
  value?: Maybe<Scalars['String']>;
};

export type TaskFilterInput = {
  stateStatus?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TaskOutput = TaskOutputInterface & {
  __typename?: 'TaskOutput';
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type TaskOutputInterface = {
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
};

export type ToBeShippedTaskOutput = TaskOutputInterface & {
  __typename?: 'ToBeShippedTaskOutput';
  /**
   *
   *
   */
  boxSize?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  cancelledBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  completedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  completedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  contexts: Array<Scalars['String']>;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  customer?: Maybe<CustomerOutput>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  id: Scalars['ID'];
  /**
   *
   *
   */
  shippingType?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedAt?: Maybe<Scalars['String']>;
  /**
   *
   *
   */
  startedBy?: Maybe<CommonUserOutputInterface>;
  /**
   *
   *
   */
  stateStatus: Scalars['String'];
  /**
   *
   *
   */
  taskType: Scalars['String'];
  /**
   *
   *
   */
  weight: Scalars['Float'];
};

export type UpdateCardPaymentInput = {
  cardToken?: Maybe<Scalars['String']>;
};

export type UpdateCustomerContactPreferencesInput = {
  allowSmsUpdates?: Maybe<Scalars['Boolean']>;
  method?: Maybe<Scalars['String']>;
};

export type UpdateCustomerDetailsInput = {
  phoneNumber?: Maybe<Scalars['String']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
};

export type UpdateCustomerNoteInput = {
  message?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['String']>;
};

export type UpdateNhsIm1Input = {
  gpLinkageKey?: Maybe<Scalars['String']>;
  gpOdsCode?: Maybe<Scalars['String']>;
  gpUserId?: Maybe<Scalars['String']>;
};

export type UpdateOrderNoteInput = {
  message?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
};

export type UpdatePaymentCardInput = {
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type VerifyEmailInput = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type VerifySmsPhoneNumberInput = {
  code: Scalars['String'];
  smsNumber: Scalars['String'];
};

export type AddDeliveryAddressMutationVariables = Exact<{
  input?: Maybe<CustomerAddressInput>;
}>;


export type AddDeliveryAddressMutation = { __typename?: 'Mutation', addDeliveryAddress: { __typename?: 'CustomerAddressOutput', id: string } };

export type AddPatientMedicationMutationVariables = Exact<{
  medicationId: Scalars['String'];
  requiredAt: Scalars['String'];
}>;


export type AddPatientMedicationMutation = { __typename?: 'Mutation', addPatientMedication?: { __typename?: 'PatientMedicationOutput', id: string } | null | undefined };

export type AllowSmsUpdatesMutationVariables = Exact<{
  allowSms: Scalars['Boolean'];
}>;


export type AllowSmsUpdatesMutation = { __typename?: 'Mutation', updateCustomerContactPreferences: boolean };

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticateUserOutput', token: string } };

export type BeginHealthServiceSignupMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type BeginHealthServiceSignupMutation = { __typename?: 'Mutation', beginHealthServiceSignup: boolean };

export type ChangeEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeCustomerEmail: boolean };

export type ChangeExemptionMutationVariables = Exact<{
  exemptionReasonId?: Maybe<Scalars['String']>;
}>;


export type ChangeExemptionMutation = { __typename?: 'Mutation', healthServicePatientAccountUpdate: boolean };

export type ChangeGpSurgeryMutationVariables = Exact<{
  surgeryId: Scalars['String'];
}>;


export type ChangeGpSurgeryMutation = { __typename?: 'Mutation', healthServicePatientAccountUpdate: boolean };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type ChangeSmsNumberMutationVariables = Exact<{
  smsNumber?: Maybe<Scalars['String']>;
}>;


export type ChangeSmsNumberMutation = { __typename?: 'Mutation', updateCustomerDetails: boolean };

export type ConnectGpSurgeryMutationVariables = Exact<{
  userId: Scalars['String'];
  odsCode: Scalars['String'];
  linkageKey: Scalars['String'];
}>;


export type ConnectGpSurgeryMutation = { __typename?: 'Mutation', updateNHSIM1?: { __typename?: 'NhsIm1AuthConnectionOutput', id?: string | null | undefined } | null | undefined };

export type CreateCardPaymentMutationVariables = Exact<{
  input?: Maybe<CreateCardPaymentInput>;
}>;


export type CreateCardPaymentMutation = { __typename?: 'Mutation', createCardPayment: { __typename?: 'CardPaymentOutput', id?: string | null | undefined, merchantSessionKey?: string | null | undefined, error?: string | null | undefined, providerError?: string | null | undefined, scaUrl?: string | null | undefined, did3dsAuthenticationPass: boolean, amount: number, isAuthorised: boolean, authorisedAmount: number } };

export type CreateRequestMedicationBasketMutationVariables = Exact<{
  patientMedicationIds: Array<Scalars['String']> | Scalars['String'];
  deliveryAddressId?: Maybe<Scalars['String']>;
}>;


export type CreateRequestMedicationBasketMutation = { __typename?: 'Mutation', createRepeatPrescriptionBasket: { __typename?: 'BasketOutput', id?: string | null | undefined, shippingPrice: number, shippingSaleTax: number, shippingTotalPrice: number, itemPriceTotal: number, itemSaleTaxTotal: number, saleTaxTotal: number, totalBeforeSaleTax: number, totalWithSaleTax: number, totalRemaining: number, itemCount: number, orderId?: string | null | undefined, items: Array<{ __typename?: 'BasketItemOutput', id?: string | null | undefined, price: number, patientMedication?: { __typename?: 'PatientMedicationOutput', id: string, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string } } | null | undefined }>, deliveryAddress?: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string } | null | undefined, discount?: { __typename?: 'DiscountOutput', id: string, code: string, description: string } | null | undefined } };

export type DeleteAccountMutationVariables = Exact<{
  reason?: Maybe<Scalars['String']>;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteCustomer: boolean };

export type DeletePatientMedicationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePatientMedicationMutation = { __typename?: 'Mutation', deletePatientMedication: boolean };

export type HealthServiceSignupMutationVariables = Exact<{
  input: HealthServiceSignupInput;
}>;


export type HealthServiceSignupMutation = { __typename?: 'Mutation', healthServiceSignup: { __typename?: 'HealthServiceSignupOutput', token: string } };

export type HealthServiceVerifyPatientMutationVariables = Exact<{
  input: HealthServiceVerifyPatientInput;
}>;


export type HealthServiceVerifyPatientMutation = { __typename?: 'Mutation', healthServiceVerifyPatient: { __typename?: 'HealthServicePatientAccountOutput', healthServiceVerificationStatus: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: string };

export type RemoveDeliveryAddressMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveDeliveryAddressMutation = { __typename?: 'Mutation', deleteDeliveryAddress: boolean };

export type RemovePaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentCard: boolean };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export type ResendVerificationSmsMutationVariables = Exact<{
  input: ResendVerificationSmsInput;
}>;


export type ResendVerificationSmsMutation = { __typename?: 'Mutation', resendVerificationSms: boolean };

export type SaveSurgeryInterestMutationVariables = Exact<{
  input?: Maybe<SaveSurgeryInterestInput>;
}>;


export type SaveSurgeryInterestMutation = { __typename?: 'Mutation', saveSurgeryInterest: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{
  input: SendResetPasswordEmailInput;
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail?: boolean | null | undefined };

export type SetPrimaryDeliveryAddressMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetPrimaryDeliveryAddressMutation = { __typename?: 'Mutation', setPrimaryDeliveryAddress: { __typename?: 'CustomerAddressOutput', id: string } };

export type SetPrimaryPaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetPrimaryPaymentMethodMutation = { __typename?: 'Mutation', setPrimaryPaymentMethod: { __typename?: 'PaymentCardOutput', id?: string | null | undefined } };

export type SetUrgentContactMethodMutationVariables = Exact<{
  method: Scalars['String'];
}>;


export type SetUrgentContactMethodMutation = { __typename?: 'Mutation', updateCustomerContactPreferences: boolean };

export type SubmitCardPaymentMutationVariables = Exact<{
  cardPaymentId: Scalars['String'];
}>;


export type SubmitCardPaymentMutation = { __typename?: 'Mutation', submitCardPayment: { __typename?: 'CardPaymentOutput', id?: string | null | undefined, error?: string | null | undefined, providerError?: string | null | undefined, merchantSessionKey?: string | null | undefined, cardToken?: string | null | undefined, scaUrl?: string | null | undefined, urlFor3ds?: string | null | undefined, did3dsAuthenticationPass: boolean, amount: number, isAuthorised: boolean, authorisedAmount: number } };

export type SubmitRepeatPrescriptionBasketMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SubmitRepeatPrescriptionBasketMutation = { __typename?: 'Mutation', submitRepeatPrescriptionBasket: { __typename?: 'BasketOutput', id?: string | null | undefined, shippingPrice: number, shippingSaleTax: number, shippingTotalPrice: number, itemPriceTotal: number, itemSaleTaxTotal: number, saleTaxTotal: number, totalBeforeSaleTax: number, totalWithSaleTax: number, totalAuthorised: number, totalRemaining: number, itemCount: number, orderId?: string | null | undefined, items: Array<{ __typename?: 'BasketItemOutput', id?: string | null | undefined, price: number, saleTax: number, quantity: number, patientMedication?: { __typename?: 'PatientMedicationOutput', id: string, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string } } | null | undefined }>, deliveryAddress?: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string } | null | undefined, discount?: { __typename?: 'DiscountOutput', id: string, code: string, description: string } | null | undefined } };

export type UpdateCardPaymentMutationVariables = Exact<{
  input?: Maybe<UpdateCardPaymentInput>;
  cardPaymentId: Scalars['String'];
}>;


export type UpdateCardPaymentMutation = { __typename?: 'Mutation', updateCardPayment: { __typename?: 'CardPaymentOutput', id?: string | null | undefined, scaUrl?: string | null | undefined, error?: string | null | undefined, providerError?: string | null | undefined, did3dsAuthenticationPass: boolean, amount: number, isAuthorised: boolean, authorisedAmount: number } };

export type UpdateDeliveryAddressMutationVariables = Exact<{
  id: Scalars['String'];
  address?: Maybe<CustomerAddressInput>;
}>;


export type UpdateDeliveryAddressMutation = { __typename?: 'Mutation', updateDeliveryAddress: { __typename?: 'CustomerAddressOutput', id: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdatePhoneNumberMutationVariables = Exact<{
  phoneNumber?: Maybe<Scalars['String']>;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updateCustomerDetails: boolean };

export type UpdateRequestMedicationBasketMutationVariables = Exact<{
  basketId: Scalars['String'];
  patientMedicationIds: Array<Scalars['String']> | Scalars['String'];
  deliveryAddressId?: Maybe<Scalars['String']>;
}>;


export type UpdateRequestMedicationBasketMutation = { __typename?: 'Mutation', updateRepeatPrescriptionBasket: { __typename?: 'BasketOutput', id?: string | null | undefined, shippingPrice: number, shippingSaleTax: number, shippingTotalPrice: number, itemPriceTotal: number, itemSaleTaxTotal: number, saleTaxTotal: number, totalBeforeSaleTax: number, totalWithSaleTax: number, totalRemaining: number, itemCount: number, orderId?: string | null | undefined, items: Array<{ __typename?: 'BasketItemOutput', id?: string | null | undefined, price: number, patientMedication?: { __typename?: 'PatientMedicationOutput', id: string, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string } } | null | undefined }>, deliveryAddress?: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string } | null | undefined, discount?: { __typename?: 'DiscountOutput', id: string, code: string, description: string } | null | undefined } };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type VerifySmsPhoneNumberMutationVariables = Exact<{
  input: VerifySmsPhoneNumberInput;
}>;


export type VerifySmsPhoneNumberMutation = { __typename?: 'Mutation', verifySmsPhoneNumber: boolean };

export type BasketQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BasketQuery = { __typename?: 'Query', basket: { __typename?: 'BasketOutput', id?: string | null | undefined, shippingPrice: number, shippingSaleTax: number, shippingTotalPrice: number, itemPriceTotal: number, itemSaleTaxTotal: number, saleTaxTotal: number, totalBeforeSaleTax: number, totalWithSaleTax: number, totalAuthorised: number, totalRemaining: number, itemCount: number, orderId?: string | null | undefined, items: Array<{ __typename?: 'BasketItemOutput', id?: string | null | undefined, price: number, saleTax: number, quantity: number, patientMedication?: { __typename?: 'PatientMedicationOutput', id: string, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string } } | null | undefined }>, deliveryAddress?: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string } | null | undefined, discount?: { __typename?: 'DiscountOutput', id: string, code: string, description: string } | null | undefined } };

export type CardPaymentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CardPaymentQuery = { __typename?: 'Query', cardPayment: { __typename?: 'CardPaymentOutput', id?: string | null | undefined, error?: string | null | undefined, providerError?: string | null | undefined, merchantSessionKey?: string | null | undefined, cardToken?: string | null | undefined, scaUrl?: string | null | undefined, urlFor3ds?: string | null | undefined, did3dsAuthenticationPass: boolean, amount: number, isAuthorised: boolean, authorisedAmount: number } };

export type DeliveryAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliveryAddressesQuery = { __typename?: 'Query', userInfo: { __typename?: 'CustomerInfoOutput', id: string, primaryDeliveryAddress: { __typename?: 'CustomerAddressOutput', id: string } }, deliveryAddresses: Array<{ __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string }> };

export type ExemptionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExemptionReasonsQuery = { __typename?: 'Query', exemptionReasons: Array<{ __typename?: 'ExemptionReasonOutput', id: string, code: string, reason: string }> };

export type MedicationSearchQueryVariables = Exact<{
  query: Scalars['String'];
  family?: Maybe<Scalars['String']>;
}>;


export type MedicationSearchQuery = { __typename?: 'Query', medicationSearch: Array<{ __typename?: 'MedicationSearchHit', medicationId: string, familyFormName: string, formName: string, name: string, familyName: string, shortFormName: string, formCategory: string, optionName: string, shortDisplayName: string, longDisplayName: string }> };

export type OrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'RepeatPrescriptionOrderOutput', id: string, orderNumber: string, shippingPrice: number, shippingSaleTax: number, itemPriceTotal: number, itemSaleTaxTotal: number, totalBeforeSaleTax: number, saleTaxTotal: number, totalWithSaleTax: number, status: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string }, notes: Array<{ __typename?: 'OrderNoteOutput', id?: string | null | undefined, message: string, createdAt: string, updatedAt: string, statusFrom: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string }, statusTo: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string } }>, customer?: { __typename?: 'CustomerOutput', firstName: string, lastName: string } | null | undefined, payments: Array<{ __typename?: 'CardPaymentOutput', id?: string | null | undefined, paymentCard?: { __typename?: 'PaymentCardOutput', last4Digits?: string | null | undefined, type: string } | null | undefined }>, exemption?: { __typename?: 'ExemptionOutput', id?: string | null | undefined, exemptionReason: { __typename?: 'ExemptionReasonOutput', id: string, code: string, reason: string } } | null | undefined, items: Array<{ __typename?: 'RepeatPrescriptionOrderItemOutput', description?: string | null | undefined, price: number, id: string, status: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string } }>, deliveryAddress?: { __typename?: 'CustomerAddressOutput', id: string, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string } | null | undefined } };

export type OrdersQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: { __typename?: 'PaginatorResult_RepeatPrescriptionOrderOutput', firstItem?: number | null | undefined, lastItem?: number | null | undefined, hasMorePages?: boolean | null | undefined, currentPage?: number | null | undefined, totalCount?: number | null | undefined, lastPage?: number | null | undefined, items: Array<{ __typename?: 'RepeatPrescriptionOrderOutput', id: string, orderNumber: string, status: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string }, notes: Array<{ __typename?: 'OrderNoteOutput', id?: string | null | undefined, createdAt: string }>, items: Array<{ __typename?: 'RepeatPrescriptionOrderItemOutput', description?: string | null | undefined, price: number, id: string, status: { __typename?: 'StatusOutput', key: string, level: string, title: string, description: string } }> }> } };

export type PatientMedicationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PatientMedicationQuery = { __typename?: 'Query', patientMedication?: { __typename?: 'PatientMedicationOutput', id: string, requiredAt?: string | null | undefined, deletedAt?: string | null | undefined, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string, formCategory?: string | null | undefined } } | null | undefined };

export type PatientMedicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PatientMedicationsQuery = { __typename?: 'Query', patientMedications: Array<{ __typename?: 'PatientMedicationOutput', id: string, requiredAt?: string | null | undefined, deletedAt?: string | null | undefined, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string, formCategory?: string | null | undefined } }> };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentCardOutput', id?: string | null | undefined, type: string, paymentProviderToken?: string | null | undefined, name?: string | null | undefined, last4Digits?: string | null | undefined, brand?: string | null | undefined }> };

export type SearchForPostcodeQueryVariables = Exact<{
  postcode: Scalars['String'];
}>;


export type SearchForPostcodeQuery = { __typename?: 'Query', searchForPostcode: Array<{ __typename?: 'GeolocationAddressOutput', addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, country?: string | null | undefined, postcode: string, summaryLine: string }> };

export type SurgerySearchQueryVariables = Exact<{
  postcode: Scalars['String'];
}>;


export type SurgerySearchQuery = { __typename?: 'Query', surgerySearch: Array<{ __typename?: 'NhsSurgeryOutput', id: string, name: string, providesPatients: boolean, isEpsEnabled: boolean, contactMethod: string, address: { __typename?: 'NhsSurgeryAddressOutput', addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, postcode: string, country?: string | null | undefined } }> };

export type TermsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsContentQuery = { __typename?: 'Query', staticContent?: { __typename?: 'StaticContentOutput', content?: string | null | undefined } | null | undefined };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { __typename?: 'Query', userInfo: { __typename?: 'CustomerInfoOutput', id: string, email: string, unverifiedEmail?: string | null | undefined, phoneNumber: string, smsPhoneNumber?: string | null | undefined, unverifiedSmsPhoneNumber?: string | null | undefined, firstName: string, lastName: string, fullName: string, gender: string, dateOfBirth?: string | null | undefined, preferredContactMethod: string, allowSmsUpdates: boolean, requiresExemptionStatusCheck: boolean, hasHealthServiceAccount: boolean, defaultAddress: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string }, primaryPaymentMethod?: { __typename?: 'PaymentCardOutput', id?: string | null | undefined } | null | undefined, primaryDeliveryAddress: { __typename?: 'CustomerAddressOutput', id: string, friendlyName?: string | null | undefined, addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city: string, county?: string | null | undefined, postcode: string, country: string }, healthServicePatientAccount?: { __typename?: 'HealthServicePatientAccountOutput', id?: string | null | undefined, canHealthServiceVerify: boolean, healthServiceVerificationStatus: string, healthServiceIdentifier?: string | null | undefined, healthServiceIdentifierLabel: string, preferredPharmacy?: string | null | undefined, patientMedications: Array<{ __typename?: 'PatientMedicationOutput', id: string, requiredAt?: string | null | undefined, deletedAt?: string | null | undefined, medication: { __typename?: 'MedicationOutput', id: string, name?: string | null | undefined, familyName?: string | null | undefined, formName?: string | null | undefined, shortFormName?: string | null | undefined, optionName?: string | null | undefined, isFemaleContraceptive: boolean, shortDisplayName: string, longDisplayName: string, formCategory?: string | null | undefined } }>, exemption?: { __typename?: 'ExemptionOutput', id?: string | null | undefined, exemptionReason: { __typename?: 'ExemptionReasonOutput', id: string, code: string, reason: string } } | null | undefined, surgery?: { __typename?: 'NhsSurgeryOutput', id: string, name: string, isEpsEnabled: boolean, address: { __typename?: 'NhsSurgeryAddressOutput', addressLine1: string, addressLine2?: string | null | undefined, addressLine3?: string | null | undefined, addressLine4?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, postcode: string } } | null | undefined } | null | undefined } };


export const AddDeliveryAddressDocument = gql`
    mutation addDeliveryAddress($input: CustomerAddressInput) {
  addDeliveryAddress(input: $input) {
    id
  }
}
    `;
export type AddDeliveryAddressMutationFn = Apollo.MutationFunction<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>;

/**
 * __useAddDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useAddDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeliveryAddressMutation, { data, loading, error }] = useAddDeliveryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>(AddDeliveryAddressDocument, options);
      }
export type AddDeliveryAddressMutationHookResult = ReturnType<typeof useAddDeliveryAddressMutation>;
export type AddDeliveryAddressMutationResult = Apollo.MutationResult<AddDeliveryAddressMutation>;
export type AddDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>;
export const AddPatientMedicationDocument = gql`
    mutation addPatientMedication($medicationId: String!, $requiredAt: String!) {
  addPatientMedication(medicationId: $medicationId, requiredAt: $requiredAt) {
    id
  }
}
    `;
export type AddPatientMedicationMutationFn = Apollo.MutationFunction<AddPatientMedicationMutation, AddPatientMedicationMutationVariables>;

/**
 * __useAddPatientMedicationMutation__
 *
 * To run a mutation, you first call `useAddPatientMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientMedicationMutation, { data, loading, error }] = useAddPatientMedicationMutation({
 *   variables: {
 *      medicationId: // value for 'medicationId'
 *      requiredAt: // value for 'requiredAt'
 *   },
 * });
 */
export function useAddPatientMedicationMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientMedicationMutation, AddPatientMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientMedicationMutation, AddPatientMedicationMutationVariables>(AddPatientMedicationDocument, options);
      }
export type AddPatientMedicationMutationHookResult = ReturnType<typeof useAddPatientMedicationMutation>;
export type AddPatientMedicationMutationResult = Apollo.MutationResult<AddPatientMedicationMutation>;
export type AddPatientMedicationMutationOptions = Apollo.BaseMutationOptions<AddPatientMedicationMutation, AddPatientMedicationMutationVariables>;
export const AllowSmsUpdatesDocument = gql`
    mutation allowSmsUpdates($allowSms: Boolean!) {
  updateCustomerContactPreferences(input: {allowSmsUpdates: $allowSms})
}
    `;
export type AllowSmsUpdatesMutationFn = Apollo.MutationFunction<AllowSmsUpdatesMutation, AllowSmsUpdatesMutationVariables>;

/**
 * __useAllowSmsUpdatesMutation__
 *
 * To run a mutation, you first call `useAllowSmsUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowSmsUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowSmsUpdatesMutation, { data, loading, error }] = useAllowSmsUpdatesMutation({
 *   variables: {
 *      allowSms: // value for 'allowSms'
 *   },
 * });
 */
export function useAllowSmsUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<AllowSmsUpdatesMutation, AllowSmsUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllowSmsUpdatesMutation, AllowSmsUpdatesMutationVariables>(AllowSmsUpdatesDocument, options);
      }
export type AllowSmsUpdatesMutationHookResult = ReturnType<typeof useAllowSmsUpdatesMutation>;
export type AllowSmsUpdatesMutationResult = Apollo.MutationResult<AllowSmsUpdatesMutation>;
export type AllowSmsUpdatesMutationOptions = Apollo.BaseMutationOptions<AllowSmsUpdatesMutation, AllowSmsUpdatesMutationVariables>;
export const AuthenticateDocument = gql`
    mutation authenticate($email: String!, $password: String!) {
  authenticate(input: {email: $email, password: $password}) {
    token
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const BeginHealthServiceSignupDocument = gql`
    mutation beginHealthServiceSignup($email: String!) {
  beginHealthServiceSignup(input: {email: $email})
}
    `;
export type BeginHealthServiceSignupMutationFn = Apollo.MutationFunction<BeginHealthServiceSignupMutation, BeginHealthServiceSignupMutationVariables>;

/**
 * __useBeginHealthServiceSignupMutation__
 *
 * To run a mutation, you first call `useBeginHealthServiceSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginHealthServiceSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginHealthServiceSignupMutation, { data, loading, error }] = useBeginHealthServiceSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useBeginHealthServiceSignupMutation(baseOptions?: Apollo.MutationHookOptions<BeginHealthServiceSignupMutation, BeginHealthServiceSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginHealthServiceSignupMutation, BeginHealthServiceSignupMutationVariables>(BeginHealthServiceSignupDocument, options);
      }
export type BeginHealthServiceSignupMutationHookResult = ReturnType<typeof useBeginHealthServiceSignupMutation>;
export type BeginHealthServiceSignupMutationResult = Apollo.MutationResult<BeginHealthServiceSignupMutation>;
export type BeginHealthServiceSignupMutationOptions = Apollo.BaseMutationOptions<BeginHealthServiceSignupMutation, BeginHealthServiceSignupMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation changeEmail($email: String!) {
  changeCustomerEmail(input: {email: $email})
}
    `;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ChangeExemptionDocument = gql`
    mutation changeExemption($exemptionReasonId: String) {
  healthServicePatientAccountUpdate(
    input: {exemptionReasonId: $exemptionReasonId}
  )
}
    `;
export type ChangeExemptionMutationFn = Apollo.MutationFunction<ChangeExemptionMutation, ChangeExemptionMutationVariables>;

/**
 * __useChangeExemptionMutation__
 *
 * To run a mutation, you first call `useChangeExemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExemptionMutation, { data, loading, error }] = useChangeExemptionMutation({
 *   variables: {
 *      exemptionReasonId: // value for 'exemptionReasonId'
 *   },
 * });
 */
export function useChangeExemptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeExemptionMutation, ChangeExemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeExemptionMutation, ChangeExemptionMutationVariables>(ChangeExemptionDocument, options);
      }
export type ChangeExemptionMutationHookResult = ReturnType<typeof useChangeExemptionMutation>;
export type ChangeExemptionMutationResult = Apollo.MutationResult<ChangeExemptionMutation>;
export type ChangeExemptionMutationOptions = Apollo.BaseMutationOptions<ChangeExemptionMutation, ChangeExemptionMutationVariables>;
export const ChangeGpSurgeryDocument = gql`
    mutation changeGpSurgery($surgeryId: String!) {
  healthServicePatientAccountUpdate(input: {surgeryId: $surgeryId})
}
    `;
export type ChangeGpSurgeryMutationFn = Apollo.MutationFunction<ChangeGpSurgeryMutation, ChangeGpSurgeryMutationVariables>;

/**
 * __useChangeGpSurgeryMutation__
 *
 * To run a mutation, you first call `useChangeGpSurgeryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGpSurgeryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGpSurgeryMutation, { data, loading, error }] = useChangeGpSurgeryMutation({
 *   variables: {
 *      surgeryId: // value for 'surgeryId'
 *   },
 * });
 */
export function useChangeGpSurgeryMutation(baseOptions?: Apollo.MutationHookOptions<ChangeGpSurgeryMutation, ChangeGpSurgeryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeGpSurgeryMutation, ChangeGpSurgeryMutationVariables>(ChangeGpSurgeryDocument, options);
      }
export type ChangeGpSurgeryMutationHookResult = ReturnType<typeof useChangeGpSurgeryMutation>;
export type ChangeGpSurgeryMutationResult = Apollo.MutationResult<ChangeGpSurgeryMutation>;
export type ChangeGpSurgeryMutationOptions = Apollo.BaseMutationOptions<ChangeGpSurgeryMutation, ChangeGpSurgeryMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeSmsNumberDocument = gql`
    mutation changeSmsNumber($smsNumber: String) {
  updateCustomerDetails(input: {smsPhoneNumber: $smsNumber})
}
    `;
export type ChangeSmsNumberMutationFn = Apollo.MutationFunction<ChangeSmsNumberMutation, ChangeSmsNumberMutationVariables>;

/**
 * __useChangeSmsNumberMutation__
 *
 * To run a mutation, you first call `useChangeSmsNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSmsNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSmsNumberMutation, { data, loading, error }] = useChangeSmsNumberMutation({
 *   variables: {
 *      smsNumber: // value for 'smsNumber'
 *   },
 * });
 */
export function useChangeSmsNumberMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSmsNumberMutation, ChangeSmsNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSmsNumberMutation, ChangeSmsNumberMutationVariables>(ChangeSmsNumberDocument, options);
      }
export type ChangeSmsNumberMutationHookResult = ReturnType<typeof useChangeSmsNumberMutation>;
export type ChangeSmsNumberMutationResult = Apollo.MutationResult<ChangeSmsNumberMutation>;
export type ChangeSmsNumberMutationOptions = Apollo.BaseMutationOptions<ChangeSmsNumberMutation, ChangeSmsNumberMutationVariables>;
export const ConnectGpSurgeryDocument = gql`
    mutation connectGPSurgery($userId: String!, $odsCode: String!, $linkageKey: String!) {
  updateNHSIM1(
    input: {gpUserId: $userId, gpOdsCode: $odsCode, gpLinkageKey: $linkageKey}
  ) {
    id
  }
}
    `;
export type ConnectGpSurgeryMutationFn = Apollo.MutationFunction<ConnectGpSurgeryMutation, ConnectGpSurgeryMutationVariables>;

/**
 * __useConnectGpSurgeryMutation__
 *
 * To run a mutation, you first call `useConnectGpSurgeryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGpSurgeryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGpSurgeryMutation, { data, loading, error }] = useConnectGpSurgeryMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      odsCode: // value for 'odsCode'
 *      linkageKey: // value for 'linkageKey'
 *   },
 * });
 */
export function useConnectGpSurgeryMutation(baseOptions?: Apollo.MutationHookOptions<ConnectGpSurgeryMutation, ConnectGpSurgeryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectGpSurgeryMutation, ConnectGpSurgeryMutationVariables>(ConnectGpSurgeryDocument, options);
      }
export type ConnectGpSurgeryMutationHookResult = ReturnType<typeof useConnectGpSurgeryMutation>;
export type ConnectGpSurgeryMutationResult = Apollo.MutationResult<ConnectGpSurgeryMutation>;
export type ConnectGpSurgeryMutationOptions = Apollo.BaseMutationOptions<ConnectGpSurgeryMutation, ConnectGpSurgeryMutationVariables>;
export const CreateCardPaymentDocument = gql`
    mutation createCardPayment($input: CreateCardPaymentInput) {
  createCardPayment(input: $input) {
    id
    merchantSessionKey
    error
    providerError
    scaUrl
    did3dsAuthenticationPass
    amount
    isAuthorised
    authorisedAmount
  }
}
    `;
export type CreateCardPaymentMutationFn = Apollo.MutationFunction<CreateCardPaymentMutation, CreateCardPaymentMutationVariables>;

/**
 * __useCreateCardPaymentMutation__
 *
 * To run a mutation, you first call `useCreateCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardPaymentMutation, { data, loading, error }] = useCreateCardPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardPaymentMutation, CreateCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardPaymentMutation, CreateCardPaymentMutationVariables>(CreateCardPaymentDocument, options);
      }
export type CreateCardPaymentMutationHookResult = ReturnType<typeof useCreateCardPaymentMutation>;
export type CreateCardPaymentMutationResult = Apollo.MutationResult<CreateCardPaymentMutation>;
export type CreateCardPaymentMutationOptions = Apollo.BaseMutationOptions<CreateCardPaymentMutation, CreateCardPaymentMutationVariables>;
export const CreateRequestMedicationBasketDocument = gql`
    mutation createRequestMedicationBasket($patientMedicationIds: [String!]!, $deliveryAddressId: String) {
  createRepeatPrescriptionBasket(
    input: {patientMedicationIds: $patientMedicationIds, deliveryAddressId: $deliveryAddressId}
  ) {
    id
    items {
      id
      price
      patientMedication {
        id
        medication {
          id
          name
          familyName
          formName
          shortFormName
          optionName
          isFemaleContraceptive
          shortDisplayName
          longDisplayName
        }
      }
    }
    shippingPrice
    shippingSaleTax
    shippingTotalPrice
    itemPriceTotal
    itemSaleTaxTotal
    saleTaxTotal
    totalBeforeSaleTax
    totalWithSaleTax
    totalRemaining
    itemCount
    deliveryAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    discount {
      id
      code
      description
    }
    orderId
  }
}
    `;
export type CreateRequestMedicationBasketMutationFn = Apollo.MutationFunction<CreateRequestMedicationBasketMutation, CreateRequestMedicationBasketMutationVariables>;

/**
 * __useCreateRequestMedicationBasketMutation__
 *
 * To run a mutation, you first call `useCreateRequestMedicationBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestMedicationBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestMedicationBasketMutation, { data, loading, error }] = useCreateRequestMedicationBasketMutation({
 *   variables: {
 *      patientMedicationIds: // value for 'patientMedicationIds'
 *      deliveryAddressId: // value for 'deliveryAddressId'
 *   },
 * });
 */
export function useCreateRequestMedicationBasketMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestMedicationBasketMutation, CreateRequestMedicationBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestMedicationBasketMutation, CreateRequestMedicationBasketMutationVariables>(CreateRequestMedicationBasketDocument, options);
      }
export type CreateRequestMedicationBasketMutationHookResult = ReturnType<typeof useCreateRequestMedicationBasketMutation>;
export type CreateRequestMedicationBasketMutationResult = Apollo.MutationResult<CreateRequestMedicationBasketMutation>;
export type CreateRequestMedicationBasketMutationOptions = Apollo.BaseMutationOptions<CreateRequestMedicationBasketMutation, CreateRequestMedicationBasketMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($reason: String) {
  deleteCustomer(input: {reason: $reason})
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeletePatientMedicationDocument = gql`
    mutation deletePatientMedication($id: String!) {
  deletePatientMedication(id: $id)
}
    `;
export type DeletePatientMedicationMutationFn = Apollo.MutationFunction<DeletePatientMedicationMutation, DeletePatientMedicationMutationVariables>;

/**
 * __useDeletePatientMedicationMutation__
 *
 * To run a mutation, you first call `useDeletePatientMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientMedicationMutation, { data, loading, error }] = useDeletePatientMedicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientMedicationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientMedicationMutation, DeletePatientMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientMedicationMutation, DeletePatientMedicationMutationVariables>(DeletePatientMedicationDocument, options);
      }
export type DeletePatientMedicationMutationHookResult = ReturnType<typeof useDeletePatientMedicationMutation>;
export type DeletePatientMedicationMutationResult = Apollo.MutationResult<DeletePatientMedicationMutation>;
export type DeletePatientMedicationMutationOptions = Apollo.BaseMutationOptions<DeletePatientMedicationMutation, DeletePatientMedicationMutationVariables>;
export const HealthServiceSignupDocument = gql`
    mutation healthServiceSignup($input: HealthServiceSignupInput!) {
  healthServiceSignup(input: $input) {
    token
  }
}
    `;
export type HealthServiceSignupMutationFn = Apollo.MutationFunction<HealthServiceSignupMutation, HealthServiceSignupMutationVariables>;

/**
 * __useHealthServiceSignupMutation__
 *
 * To run a mutation, you first call `useHealthServiceSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHealthServiceSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [healthServiceSignupMutation, { data, loading, error }] = useHealthServiceSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHealthServiceSignupMutation(baseOptions?: Apollo.MutationHookOptions<HealthServiceSignupMutation, HealthServiceSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HealthServiceSignupMutation, HealthServiceSignupMutationVariables>(HealthServiceSignupDocument, options);
      }
export type HealthServiceSignupMutationHookResult = ReturnType<typeof useHealthServiceSignupMutation>;
export type HealthServiceSignupMutationResult = Apollo.MutationResult<HealthServiceSignupMutation>;
export type HealthServiceSignupMutationOptions = Apollo.BaseMutationOptions<HealthServiceSignupMutation, HealthServiceSignupMutationVariables>;
export const HealthServiceVerifyPatientDocument = gql`
    mutation healthServiceVerifyPatient($input: HealthServiceVerifyPatientInput!) {
  healthServiceVerifyPatient(input: $input) {
    healthServiceVerificationStatus
  }
}
    `;
export type HealthServiceVerifyPatientMutationFn = Apollo.MutationFunction<HealthServiceVerifyPatientMutation, HealthServiceVerifyPatientMutationVariables>;

/**
 * __useHealthServiceVerifyPatientMutation__
 *
 * To run a mutation, you first call `useHealthServiceVerifyPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHealthServiceVerifyPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [healthServiceVerifyPatientMutation, { data, loading, error }] = useHealthServiceVerifyPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHealthServiceVerifyPatientMutation(baseOptions?: Apollo.MutationHookOptions<HealthServiceVerifyPatientMutation, HealthServiceVerifyPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HealthServiceVerifyPatientMutation, HealthServiceVerifyPatientMutationVariables>(HealthServiceVerifyPatientDocument, options);
      }
export type HealthServiceVerifyPatientMutationHookResult = ReturnType<typeof useHealthServiceVerifyPatientMutation>;
export type HealthServiceVerifyPatientMutationResult = Apollo.MutationResult<HealthServiceVerifyPatientMutation>;
export type HealthServiceVerifyPatientMutationOptions = Apollo.BaseMutationOptions<HealthServiceVerifyPatientMutation, HealthServiceVerifyPatientMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RemoveDeliveryAddressDocument = gql`
    mutation removeDeliveryAddress($id: String!) {
  deleteDeliveryAddress(id: $id)
}
    `;
export type RemoveDeliveryAddressMutationFn = Apollo.MutationFunction<RemoveDeliveryAddressMutation, RemoveDeliveryAddressMutationVariables>;

/**
 * __useRemoveDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useRemoveDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDeliveryAddressMutation, { data, loading, error }] = useRemoveDeliveryAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDeliveryAddressMutation, RemoveDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDeliveryAddressMutation, RemoveDeliveryAddressMutationVariables>(RemoveDeliveryAddressDocument, options);
      }
export type RemoveDeliveryAddressMutationHookResult = ReturnType<typeof useRemoveDeliveryAddressMutation>;
export type RemoveDeliveryAddressMutationResult = Apollo.MutationResult<RemoveDeliveryAddressMutation>;
export type RemoveDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<RemoveDeliveryAddressMutation, RemoveDeliveryAddressMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation removePaymentMethod($id: String!) {
  deletePaymentCard(id: $id)
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail {
  resendVerificationEmail
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResendVerificationSmsDocument = gql`
    mutation resendVerificationSms($input: ResendVerificationSmsInput!) {
  resendVerificationSms(input: $input)
}
    `;
export type ResendVerificationSmsMutationFn = Apollo.MutationFunction<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>;

/**
 * __useResendVerificationSmsMutation__
 *
 * To run a mutation, you first call `useResendVerificationSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationSmsMutation, { data, loading, error }] = useResendVerificationSmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendVerificationSmsMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>(ResendVerificationSmsDocument, options);
      }
export type ResendVerificationSmsMutationHookResult = ReturnType<typeof useResendVerificationSmsMutation>;
export type ResendVerificationSmsMutationResult = Apollo.MutationResult<ResendVerificationSmsMutation>;
export type ResendVerificationSmsMutationOptions = Apollo.BaseMutationOptions<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>;
export const SaveSurgeryInterestDocument = gql`
    mutation saveSurgeryInterest($input: SaveSurgeryInterestInput) {
  saveSurgeryInterest(input: $input)
}
    `;
export type SaveSurgeryInterestMutationFn = Apollo.MutationFunction<SaveSurgeryInterestMutation, SaveSurgeryInterestMutationVariables>;

/**
 * __useSaveSurgeryInterestMutation__
 *
 * To run a mutation, you first call `useSaveSurgeryInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurgeryInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurgeryInterestMutation, { data, loading, error }] = useSaveSurgeryInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSurgeryInterestMutation(baseOptions?: Apollo.MutationHookOptions<SaveSurgeryInterestMutation, SaveSurgeryInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSurgeryInterestMutation, SaveSurgeryInterestMutationVariables>(SaveSurgeryInterestDocument, options);
      }
export type SaveSurgeryInterestMutationHookResult = ReturnType<typeof useSaveSurgeryInterestMutation>;
export type SaveSurgeryInterestMutationResult = Apollo.MutationResult<SaveSurgeryInterestMutation>;
export type SaveSurgeryInterestMutationOptions = Apollo.BaseMutationOptions<SaveSurgeryInterestMutation, SaveSurgeryInterestMutationVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation sendResetPasswordEmail($input: SendResetPasswordEmailInput!) {
  sendResetPasswordEmail(input: $input)
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SetPrimaryDeliveryAddressDocument = gql`
    mutation setPrimaryDeliveryAddress($id: String!) {
  setPrimaryDeliveryAddress(id: $id) {
    id
  }
}
    `;
export type SetPrimaryDeliveryAddressMutationFn = Apollo.MutationFunction<SetPrimaryDeliveryAddressMutation, SetPrimaryDeliveryAddressMutationVariables>;

/**
 * __useSetPrimaryDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useSetPrimaryDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryDeliveryAddressMutation, { data, loading, error }] = useSetPrimaryDeliveryAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryDeliveryAddressMutation, SetPrimaryDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryDeliveryAddressMutation, SetPrimaryDeliveryAddressMutationVariables>(SetPrimaryDeliveryAddressDocument, options);
      }
export type SetPrimaryDeliveryAddressMutationHookResult = ReturnType<typeof useSetPrimaryDeliveryAddressMutation>;
export type SetPrimaryDeliveryAddressMutationResult = Apollo.MutationResult<SetPrimaryDeliveryAddressMutation>;
export type SetPrimaryDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<SetPrimaryDeliveryAddressMutation, SetPrimaryDeliveryAddressMutationVariables>;
export const SetPrimaryPaymentMethodDocument = gql`
    mutation setPrimaryPaymentMethod($id: String!) {
  setPrimaryPaymentMethod(id: $id) {
    id
  }
}
    `;
export type SetPrimaryPaymentMethodMutationFn = Apollo.MutationFunction<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>;

/**
 * __useSetPrimaryPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetPrimaryPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryPaymentMethodMutation, { data, loading, error }] = useSetPrimaryPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>(SetPrimaryPaymentMethodDocument, options);
      }
export type SetPrimaryPaymentMethodMutationHookResult = ReturnType<typeof useSetPrimaryPaymentMethodMutation>;
export type SetPrimaryPaymentMethodMutationResult = Apollo.MutationResult<SetPrimaryPaymentMethodMutation>;
export type SetPrimaryPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>;
export const SetUrgentContactMethodDocument = gql`
    mutation setUrgentContactMethod($method: String!) {
  updateCustomerContactPreferences(input: {method: $method})
}
    `;
export type SetUrgentContactMethodMutationFn = Apollo.MutationFunction<SetUrgentContactMethodMutation, SetUrgentContactMethodMutationVariables>;

/**
 * __useSetUrgentContactMethodMutation__
 *
 * To run a mutation, you first call `useSetUrgentContactMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUrgentContactMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUrgentContactMethodMutation, { data, loading, error }] = useSetUrgentContactMethodMutation({
 *   variables: {
 *      method: // value for 'method'
 *   },
 * });
 */
export function useSetUrgentContactMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetUrgentContactMethodMutation, SetUrgentContactMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUrgentContactMethodMutation, SetUrgentContactMethodMutationVariables>(SetUrgentContactMethodDocument, options);
      }
export type SetUrgentContactMethodMutationHookResult = ReturnType<typeof useSetUrgentContactMethodMutation>;
export type SetUrgentContactMethodMutationResult = Apollo.MutationResult<SetUrgentContactMethodMutation>;
export type SetUrgentContactMethodMutationOptions = Apollo.BaseMutationOptions<SetUrgentContactMethodMutation, SetUrgentContactMethodMutationVariables>;
export const SubmitCardPaymentDocument = gql`
    mutation submitCardPayment($cardPaymentId: String!) {
  submitCardPayment(id: $cardPaymentId) {
    id
    error
    providerError
    merchantSessionKey
    cardToken
    scaUrl
    urlFor3ds
    did3dsAuthenticationPass
    amount
    isAuthorised
    authorisedAmount
  }
}
    `;
export type SubmitCardPaymentMutationFn = Apollo.MutationFunction<SubmitCardPaymentMutation, SubmitCardPaymentMutationVariables>;

/**
 * __useSubmitCardPaymentMutation__
 *
 * To run a mutation, you first call `useSubmitCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCardPaymentMutation, { data, loading, error }] = useSubmitCardPaymentMutation({
 *   variables: {
 *      cardPaymentId: // value for 'cardPaymentId'
 *   },
 * });
 */
export function useSubmitCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCardPaymentMutation, SubmitCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCardPaymentMutation, SubmitCardPaymentMutationVariables>(SubmitCardPaymentDocument, options);
      }
export type SubmitCardPaymentMutationHookResult = ReturnType<typeof useSubmitCardPaymentMutation>;
export type SubmitCardPaymentMutationResult = Apollo.MutationResult<SubmitCardPaymentMutation>;
export type SubmitCardPaymentMutationOptions = Apollo.BaseMutationOptions<SubmitCardPaymentMutation, SubmitCardPaymentMutationVariables>;
export const SubmitRepeatPrescriptionBasketDocument = gql`
    mutation submitRepeatPrescriptionBasket($id: String!) {
  submitRepeatPrescriptionBasket(input: {id: $id}) {
    id
    items {
      id
      price
      saleTax
      quantity
      patientMedication {
        id
        medication {
          id
          name
          familyName
          formName
          shortFormName
          optionName
          isFemaleContraceptive
          shortDisplayName
          longDisplayName
        }
      }
    }
    shippingPrice
    shippingSaleTax
    shippingTotalPrice
    itemPriceTotal
    itemSaleTaxTotal
    saleTaxTotal
    totalBeforeSaleTax
    totalWithSaleTax
    totalAuthorised
    totalRemaining
    itemCount
    deliveryAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    discount {
      id
      code
      description
    }
    orderId
  }
}
    `;
export type SubmitRepeatPrescriptionBasketMutationFn = Apollo.MutationFunction<SubmitRepeatPrescriptionBasketMutation, SubmitRepeatPrescriptionBasketMutationVariables>;

/**
 * __useSubmitRepeatPrescriptionBasketMutation__
 *
 * To run a mutation, you first call `useSubmitRepeatPrescriptionBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRepeatPrescriptionBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRepeatPrescriptionBasketMutation, { data, loading, error }] = useSubmitRepeatPrescriptionBasketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitRepeatPrescriptionBasketMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRepeatPrescriptionBasketMutation, SubmitRepeatPrescriptionBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRepeatPrescriptionBasketMutation, SubmitRepeatPrescriptionBasketMutationVariables>(SubmitRepeatPrescriptionBasketDocument, options);
      }
export type SubmitRepeatPrescriptionBasketMutationHookResult = ReturnType<typeof useSubmitRepeatPrescriptionBasketMutation>;
export type SubmitRepeatPrescriptionBasketMutationResult = Apollo.MutationResult<SubmitRepeatPrescriptionBasketMutation>;
export type SubmitRepeatPrescriptionBasketMutationOptions = Apollo.BaseMutationOptions<SubmitRepeatPrescriptionBasketMutation, SubmitRepeatPrescriptionBasketMutationVariables>;
export const UpdateCardPaymentDocument = gql`
    mutation updateCardPayment($input: UpdateCardPaymentInput, $cardPaymentId: String!) {
  updateCardPayment(input: $input, id: $cardPaymentId) {
    id
    scaUrl
    error
    providerError
    did3dsAuthenticationPass
    amount
    isAuthorised
    authorisedAmount
  }
}
    `;
export type UpdateCardPaymentMutationFn = Apollo.MutationFunction<UpdateCardPaymentMutation, UpdateCardPaymentMutationVariables>;

/**
 * __useUpdateCardPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardPaymentMutation, { data, loading, error }] = useUpdateCardPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      cardPaymentId: // value for 'cardPaymentId'
 *   },
 * });
 */
export function useUpdateCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardPaymentMutation, UpdateCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardPaymentMutation, UpdateCardPaymentMutationVariables>(UpdateCardPaymentDocument, options);
      }
export type UpdateCardPaymentMutationHookResult = ReturnType<typeof useUpdateCardPaymentMutation>;
export type UpdateCardPaymentMutationResult = Apollo.MutationResult<UpdateCardPaymentMutation>;
export type UpdateCardPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateCardPaymentMutation, UpdateCardPaymentMutationVariables>;
export const UpdateDeliveryAddressDocument = gql`
    mutation updateDeliveryAddress($id: String!, $address: CustomerAddressInput) {
  updateDeliveryAddress(id: $id, input: $address) {
    id
  }
}
    `;
export type UpdateDeliveryAddressMutationFn = Apollo.MutationFunction<UpdateDeliveryAddressMutation, UpdateDeliveryAddressMutationVariables>;

/**
 * __useUpdateDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryAddressMutation, { data, loading, error }] = useUpdateDeliveryAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryAddressMutation, UpdateDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryAddressMutation, UpdateDeliveryAddressMutationVariables>(UpdateDeliveryAddressDocument, options);
      }
export type UpdateDeliveryAddressMutationHookResult = ReturnType<typeof useUpdateDeliveryAddressMutation>;
export type UpdateDeliveryAddressMutationResult = Apollo.MutationResult<UpdateDeliveryAddressMutation>;
export type UpdateDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryAddressMutation, UpdateDeliveryAddressMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePhoneNumberDocument = gql`
    mutation updatePhoneNumber($phoneNumber: String) {
  updateCustomerDetails(input: {phoneNumber: $phoneNumber})
}
    `;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const UpdateRequestMedicationBasketDocument = gql`
    mutation updateRequestMedicationBasket($basketId: String!, $patientMedicationIds: [String!]!, $deliveryAddressId: String) {
  updateRepeatPrescriptionBasket(
    id: $basketId
    input: {patientMedicationIds: $patientMedicationIds, deliveryAddressId: $deliveryAddressId}
  ) {
    id
    items {
      id
      price
      patientMedication {
        id
        medication {
          id
          name
          familyName
          formName
          shortFormName
          optionName
          isFemaleContraceptive
          shortDisplayName
          longDisplayName
        }
      }
    }
    shippingPrice
    shippingSaleTax
    shippingTotalPrice
    itemPriceTotal
    itemSaleTaxTotal
    saleTaxTotal
    totalBeforeSaleTax
    totalWithSaleTax
    totalRemaining
    itemCount
    deliveryAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    discount {
      id
      code
      description
    }
    orderId
  }
}
    `;
export type UpdateRequestMedicationBasketMutationFn = Apollo.MutationFunction<UpdateRequestMedicationBasketMutation, UpdateRequestMedicationBasketMutationVariables>;

/**
 * __useUpdateRequestMedicationBasketMutation__
 *
 * To run a mutation, you first call `useUpdateRequestMedicationBasketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestMedicationBasketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestMedicationBasketMutation, { data, loading, error }] = useUpdateRequestMedicationBasketMutation({
 *   variables: {
 *      basketId: // value for 'basketId'
 *      patientMedicationIds: // value for 'patientMedicationIds'
 *      deliveryAddressId: // value for 'deliveryAddressId'
 *   },
 * });
 */
export function useUpdateRequestMedicationBasketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestMedicationBasketMutation, UpdateRequestMedicationBasketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestMedicationBasketMutation, UpdateRequestMedicationBasketMutationVariables>(UpdateRequestMedicationBasketDocument, options);
      }
export type UpdateRequestMedicationBasketMutationHookResult = ReturnType<typeof useUpdateRequestMedicationBasketMutation>;
export type UpdateRequestMedicationBasketMutationResult = Apollo.MutationResult<UpdateRequestMedicationBasketMutation>;
export type UpdateRequestMedicationBasketMutationOptions = Apollo.BaseMutationOptions<UpdateRequestMedicationBasketMutation, UpdateRequestMedicationBasketMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const VerifySmsPhoneNumberDocument = gql`
    mutation verifySmsPhoneNumber($input: VerifySmsPhoneNumberInput!) {
  verifySmsPhoneNumber(input: $input)
}
    `;
export type VerifySmsPhoneNumberMutationFn = Apollo.MutationFunction<VerifySmsPhoneNumberMutation, VerifySmsPhoneNumberMutationVariables>;

/**
 * __useVerifySmsPhoneNumberMutation__
 *
 * To run a mutation, you first call `useVerifySmsPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySmsPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySmsPhoneNumberMutation, { data, loading, error }] = useVerifySmsPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifySmsPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<VerifySmsPhoneNumberMutation, VerifySmsPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySmsPhoneNumberMutation, VerifySmsPhoneNumberMutationVariables>(VerifySmsPhoneNumberDocument, options);
      }
export type VerifySmsPhoneNumberMutationHookResult = ReturnType<typeof useVerifySmsPhoneNumberMutation>;
export type VerifySmsPhoneNumberMutationResult = Apollo.MutationResult<VerifySmsPhoneNumberMutation>;
export type VerifySmsPhoneNumberMutationOptions = Apollo.BaseMutationOptions<VerifySmsPhoneNumberMutation, VerifySmsPhoneNumberMutationVariables>;
export const BasketDocument = gql`
    query basket($id: String!) {
  basket(id: $id) {
    id
    items {
      id
      price
      saleTax
      quantity
      patientMedication {
        id
        medication {
          id
          name
          familyName
          formName
          shortFormName
          optionName
          isFemaleContraceptive
          shortDisplayName
          longDisplayName
        }
      }
    }
    shippingPrice
    shippingSaleTax
    shippingTotalPrice
    itemPriceTotal
    itemSaleTaxTotal
    saleTaxTotal
    totalBeforeSaleTax
    totalWithSaleTax
    totalAuthorised
    totalRemaining
    itemCount
    deliveryAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    discount {
      id
      code
      description
    }
    orderId
  }
}
    `;

/**
 * __useBasketQuery__
 *
 * To run a query within a React component, call `useBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBasketQuery(baseOptions: Apollo.QueryHookOptions<BasketQuery, BasketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasketQuery, BasketQueryVariables>(BasketDocument, options);
      }
export function useBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasketQuery, BasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasketQuery, BasketQueryVariables>(BasketDocument, options);
        }
export type BasketQueryHookResult = ReturnType<typeof useBasketQuery>;
export type BasketLazyQueryHookResult = ReturnType<typeof useBasketLazyQuery>;
export type BasketQueryResult = Apollo.QueryResult<BasketQuery, BasketQueryVariables>;
export const CardPaymentDocument = gql`
    query cardPayment($id: String!) {
  cardPayment(id: $id) {
    id
    error
    providerError
    merchantSessionKey
    cardToken
    scaUrl
    urlFor3ds
    did3dsAuthenticationPass
    amount
    isAuthorised
    authorisedAmount
  }
}
    `;

/**
 * __useCardPaymentQuery__
 *
 * To run a query within a React component, call `useCardPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardPaymentQuery(baseOptions: Apollo.QueryHookOptions<CardPaymentQuery, CardPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardPaymentQuery, CardPaymentQueryVariables>(CardPaymentDocument, options);
      }
export function useCardPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardPaymentQuery, CardPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardPaymentQuery, CardPaymentQueryVariables>(CardPaymentDocument, options);
        }
export type CardPaymentQueryHookResult = ReturnType<typeof useCardPaymentQuery>;
export type CardPaymentLazyQueryHookResult = ReturnType<typeof useCardPaymentLazyQuery>;
export type CardPaymentQueryResult = Apollo.QueryResult<CardPaymentQuery, CardPaymentQueryVariables>;
export const DeliveryAddressesDocument = gql`
    query deliveryAddresses {
  userInfo {
    id
    primaryDeliveryAddress {
      id
    }
  }
  deliveryAddresses {
    id
    friendlyName
    addressLine1
    addressLine2
    addressLine3
    addressLine4
    city
    county
    postcode
    country
  }
}
    `;

/**
 * __useDeliveryAddressesQuery__
 *
 * To run a query within a React component, call `useDeliveryAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryAddressesQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
      }
export function useDeliveryAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
        }
export type DeliveryAddressesQueryHookResult = ReturnType<typeof useDeliveryAddressesQuery>;
export type DeliveryAddressesLazyQueryHookResult = ReturnType<typeof useDeliveryAddressesLazyQuery>;
export type DeliveryAddressesQueryResult = Apollo.QueryResult<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>;
export const ExemptionReasonsDocument = gql`
    query exemptionReasons {
  exemptionReasons {
    id
    code
    reason
  }
}
    `;

/**
 * __useExemptionReasonsQuery__
 *
 * To run a query within a React component, call `useExemptionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExemptionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExemptionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExemptionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<ExemptionReasonsQuery, ExemptionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExemptionReasonsQuery, ExemptionReasonsQueryVariables>(ExemptionReasonsDocument, options);
      }
export function useExemptionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExemptionReasonsQuery, ExemptionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExemptionReasonsQuery, ExemptionReasonsQueryVariables>(ExemptionReasonsDocument, options);
        }
export type ExemptionReasonsQueryHookResult = ReturnType<typeof useExemptionReasonsQuery>;
export type ExemptionReasonsLazyQueryHookResult = ReturnType<typeof useExemptionReasonsLazyQuery>;
export type ExemptionReasonsQueryResult = Apollo.QueryResult<ExemptionReasonsQuery, ExemptionReasonsQueryVariables>;
export const MedicationSearchDocument = gql`
    query medicationSearch($query: String!, $family: String) {
  medicationSearch(query: $query, family: $family) {
    medicationId
    familyFormName
    formName
    name
    familyName
    shortFormName
    formCategory
    optionName
    shortDisplayName
    longDisplayName
  }
}
    `;

/**
 * __useMedicationSearchQuery__
 *
 * To run a query within a React component, call `useMedicationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      family: // value for 'family'
 *   },
 * });
 */
export function useMedicationSearchQuery(baseOptions: Apollo.QueryHookOptions<MedicationSearchQuery, MedicationSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicationSearchQuery, MedicationSearchQueryVariables>(MedicationSearchDocument, options);
      }
export function useMedicationSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicationSearchQuery, MedicationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicationSearchQuery, MedicationSearchQueryVariables>(MedicationSearchDocument, options);
        }
export type MedicationSearchQueryHookResult = ReturnType<typeof useMedicationSearchQuery>;
export type MedicationSearchLazyQueryHookResult = ReturnType<typeof useMedicationSearchLazyQuery>;
export type MedicationSearchQueryResult = Apollo.QueryResult<MedicationSearchQuery, MedicationSearchQueryVariables>;
export const OrderDocument = gql`
    query order($id: String!) {
  order(id: $id) {
    id
    orderNumber
    status {
      key
      level
      title
      description
    }
    notes {
      id
      statusFrom {
        key
        level
        title
        description
      }
      statusTo {
        key
        level
        title
        description
      }
      message
      createdAt
      updatedAt
    }
    customer {
      firstName
      lastName
    }
    payments {
      id
      paymentCard {
        last4Digits
        type
      }
    }
    exemption {
      id
      exemptionReason {
        id
        code
        reason
      }
    }
    items {
      status {
        key
        level
        title
        description
      }
      description
      price
      id
    }
    shippingPrice
    shippingSaleTax
    itemPriceTotal
    itemSaleTaxTotal
    totalBeforeSaleTax
    saleTaxTotal
    totalBeforeSaleTax
    totalWithSaleTax
    deliveryAddress {
      id
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrdersDocument = gql`
    query orders($offset: Int, $limit: Int) {
  orders(offset: $offset, limit: $limit) {
    items {
      id
      orderNumber
      status {
        key
        level
        title
        description
      }
      notes {
        id
        createdAt
      }
      items {
        status {
          key
          level
          title
          description
        }
        description
        price
        id
      }
    }
    firstItem
    lastItem
    hasMorePages
    currentPage
    totalCount
    lastPage
  }
}
    `;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const PatientMedicationDocument = gql`
    query patientMedication($id: String!) {
  patientMedication(id: $id) {
    id
    requiredAt
    medication {
      id
      name
      familyName
      formName
      shortFormName
      optionName
      isFemaleContraceptive
      shortDisplayName
      longDisplayName
      formCategory
    }
    deletedAt
  }
}
    `;

/**
 * __usePatientMedicationQuery__
 *
 * To run a query within a React component, call `usePatientMedicationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientMedicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientMedicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePatientMedicationQuery(baseOptions: Apollo.QueryHookOptions<PatientMedicationQuery, PatientMedicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientMedicationQuery, PatientMedicationQueryVariables>(PatientMedicationDocument, options);
      }
export function usePatientMedicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientMedicationQuery, PatientMedicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientMedicationQuery, PatientMedicationQueryVariables>(PatientMedicationDocument, options);
        }
export type PatientMedicationQueryHookResult = ReturnType<typeof usePatientMedicationQuery>;
export type PatientMedicationLazyQueryHookResult = ReturnType<typeof usePatientMedicationLazyQuery>;
export type PatientMedicationQueryResult = Apollo.QueryResult<PatientMedicationQuery, PatientMedicationQueryVariables>;
export const PatientMedicationsDocument = gql`
    query patientMedications {
  patientMedications {
    id
    requiredAt
    medication {
      id
      name
      familyName
      formName
      shortFormName
      optionName
      isFemaleContraceptive
      shortDisplayName
      longDisplayName
      formCategory
    }
    deletedAt
  }
}
    `;

/**
 * __usePatientMedicationsQuery__
 *
 * To run a query within a React component, call `usePatientMedicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientMedicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientMedicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePatientMedicationsQuery(baseOptions?: Apollo.QueryHookOptions<PatientMedicationsQuery, PatientMedicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientMedicationsQuery, PatientMedicationsQueryVariables>(PatientMedicationsDocument, options);
      }
export function usePatientMedicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientMedicationsQuery, PatientMedicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientMedicationsQuery, PatientMedicationsQueryVariables>(PatientMedicationsDocument, options);
        }
export type PatientMedicationsQueryHookResult = ReturnType<typeof usePatientMedicationsQuery>;
export type PatientMedicationsLazyQueryHookResult = ReturnType<typeof usePatientMedicationsLazyQuery>;
export type PatientMedicationsQueryResult = Apollo.QueryResult<PatientMedicationsQuery, PatientMedicationsQueryVariables>;
export const PaymentMethodsDocument = gql`
    query paymentMethods {
  paymentMethods {
    id
    type
    paymentProviderToken
    name
    last4Digits
    brand
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const SearchForPostcodeDocument = gql`
    query searchForPostcode($postcode: String!) {
  searchForPostcode(postcode: $postcode) {
    addressLine1
    addressLine2
    addressLine3
    addressLine4
    city
    county
    country
    postcode
    summaryLine
  }
}
    `;

/**
 * __useSearchForPostcodeQuery__
 *
 * To run a query within a React component, call `useSearchForPostcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForPostcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForPostcodeQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useSearchForPostcodeQuery(baseOptions: Apollo.QueryHookOptions<SearchForPostcodeQuery, SearchForPostcodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForPostcodeQuery, SearchForPostcodeQueryVariables>(SearchForPostcodeDocument, options);
      }
export function useSearchForPostcodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForPostcodeQuery, SearchForPostcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForPostcodeQuery, SearchForPostcodeQueryVariables>(SearchForPostcodeDocument, options);
        }
export type SearchForPostcodeQueryHookResult = ReturnType<typeof useSearchForPostcodeQuery>;
export type SearchForPostcodeLazyQueryHookResult = ReturnType<typeof useSearchForPostcodeLazyQuery>;
export type SearchForPostcodeQueryResult = Apollo.QueryResult<SearchForPostcodeQuery, SearchForPostcodeQueryVariables>;
export const SurgerySearchDocument = gql`
    query surgerySearch($postcode: String!) {
  surgerySearch(postcode: $postcode) {
    id
    name
    providesPatients
    isEpsEnabled
    contactMethod
    address {
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
  }
}
    `;

/**
 * __useSurgerySearchQuery__
 *
 * To run a query within a React component, call `useSurgerySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurgerySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurgerySearchQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useSurgerySearchQuery(baseOptions: Apollo.QueryHookOptions<SurgerySearchQuery, SurgerySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurgerySearchQuery, SurgerySearchQueryVariables>(SurgerySearchDocument, options);
      }
export function useSurgerySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurgerySearchQuery, SurgerySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurgerySearchQuery, SurgerySearchQueryVariables>(SurgerySearchDocument, options);
        }
export type SurgerySearchQueryHookResult = ReturnType<typeof useSurgerySearchQuery>;
export type SurgerySearchLazyQueryHookResult = ReturnType<typeof useSurgerySearchLazyQuery>;
export type SurgerySearchQueryResult = Apollo.QueryResult<SurgerySearchQuery, SurgerySearchQueryVariables>;
export const TermsContentDocument = gql`
    query termsContent {
  staticContent(input: {key: "terms"}) {
    content
  }
}
    `;

/**
 * __useTermsContentQuery__
 *
 * To run a query within a React component, call `useTermsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsContentQuery(baseOptions?: Apollo.QueryHookOptions<TermsContentQuery, TermsContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsContentQuery, TermsContentQueryVariables>(TermsContentDocument, options);
      }
export function useTermsContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsContentQuery, TermsContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsContentQuery, TermsContentQueryVariables>(TermsContentDocument, options);
        }
export type TermsContentQueryHookResult = ReturnType<typeof useTermsContentQuery>;
export type TermsContentLazyQueryHookResult = ReturnType<typeof useTermsContentLazyQuery>;
export type TermsContentQueryResult = Apollo.QueryResult<TermsContentQuery, TermsContentQueryVariables>;
export const UserInfoDocument = gql`
    query userInfo {
  userInfo {
    id
    email
    unverifiedEmail
    phoneNumber
    smsPhoneNumber
    unverifiedSmsPhoneNumber
    firstName
    lastName
    fullName
    gender
    dateOfBirth
    preferredContactMethod
    allowSmsUpdates
    requiresExemptionStatusCheck
    defaultAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    primaryPaymentMethod {
      id
    }
    primaryDeliveryAddress {
      id
      friendlyName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      county
      postcode
      country
    }
    hasHealthServiceAccount
    healthServicePatientAccount {
      id
      canHealthServiceVerify
      healthServiceVerificationStatus
      patientMedications {
        id
        requiredAt
        medication {
          id
          name
          familyName
          formName
          shortFormName
          optionName
          isFemaleContraceptive
          shortDisplayName
          longDisplayName
          formCategory
        }
        deletedAt
      }
      exemption {
        id
        exemptionReason {
          id
          code
          reason
        }
      }
      healthServiceIdentifier
      healthServiceIdentifierLabel
      preferredPharmacy
      surgery {
        id
        name
        isEpsEnabled
        address {
          addressLine1
          addressLine2
          addressLine3
          addressLine4
          city
          county
          postcode
        }
      }
    }
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;